<template>
  <div class="no-scroll">
    <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition" v-model="snackbar" timeout="5000" :value="true" :color="snackbarclr" absolute outlined top right>
      <v-icon class="mr-2" :color="snackbarclr">mdi-alert-outline</v-icon>
      {{ snackmsgbar }}
      <v-icon @click="snackbar = false" class="float-right" :color="snackbarclr">mdi-close-circle</v-icon>
    </v-snackbar>
    <LayOut />
    <v-container class="px-md-6 pt-14 no-scroll" fluid fill-height style="height: 100vh; overflow: scroll">
      <v-row no-glutters class="pt-sm-2 pb-sm-4">
        <v-col cols="12" sm="6" md="3">
          <v-card width="100%" class="elevation-0 rounded-lg px-4 py-2 text-center" outlined
            ><b>{{ viewcount ? viewcount : 0 }}</b> <br />Requested</v-card
          >
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-card width="100%" class="elevation-0 rounded-lg px-4 py-2 text-center" outlined
            ><b>{{ esigncount ? esigncount : 0 }}</b> <br />E-signed</v-card
          >
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-card width="100%" class="elevation-0 rounded-lg px-4 py-2 text-center" outlined
            ><b>{{ esignpcount ? esignpcount : 0 }} </b><br />E-sign pending</v-card
          >
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-card width="100%" class="elevation-0 rounded-lg px-4 py-2 text-center" outlined>
            Completed : <b>{{ comcount ? comcount : 0 }}</b> <br />
            Rejected : <b>{{ rejcount ? rejcount : 0 }}</b>
          </v-card>
        </v-col>
      </v-row>
      <v-card width="100%" class="elevation-0 rounded-lg mt-auto" outlined>
        <v-data-table
          ref="ovrtable"
          height="calc(100vh - 276px)"
          dense
          style="overflow: auto"
          fixed-header
          must-sort
          :search="search"
          :sort-by="[tab == 2 ? 'rejection_date_time' : tab == 1 ? 'approval_date_time' : 'date_time']"
          :sort-desc="[true]"
          :headers="tab == 0 ? headers : tab == 1 ? headersc : tab == 2 ? headersr : headers"
          :items="itemsWithSno"
          :loading="mainloader"
          hide-default-footer
          :items-per-page="-1"
          class="elevation-0"
          mobile-breakpoint
          item-key="sno"
        >
          <template v-slot:top>
            <v-toolbar dense flat>
              <v-tabs dense @change="setTypedata()" v-model="tab">
                <v-tab class="text-none">
                  <v-badge :content="viewcount" :value="viewcount">
                    <span> View </span>
                  </v-badge>
                </v-tab>
                <v-tab class="text-none">
                  <v-badge :content="comcount" :value="comcount">
                    <span> Complete </span>
                  </v-badge>
                </v-tab>
                <v-tab class="text-none">
                  <v-badge :content="rejcount" :value="rejcount">
                    <span> Reject </span>
                  </v-badge>
                </v-tab>
              </v-tabs>
              <v-spacer></v-spacer>
              <v-menu v-model="menu22" :close-on-content-click="false" transition="scale-transition" offset-y>
                <template v-slot:activator="{on, attrs}">
                  <v-text-field v-bind="attrs" v-on="on" readonly color="#fb8c00" :disabled="mainloader" dense @click:clear="dateClear()" clearable v-model="alldate" class="rounded-lg mr-4" style="min-width: 200px" prepend-inner-icon="mdi-calendar" label="Date filter" single-line hide-details>
                  </v-text-field>
                </template>
                <v-card width="580px">
                  <v-row no-gutters>
                    <v-col cols="6">
                      <v-date-picker v-model="dateSelect2" :max="maxDate2"></v-date-picker>
                    </v-col>
                    <v-col cols="6">
                      <v-date-picker v-model="dateSelectto" :min="dateSelect2" :max="maxDate2" @input="(menu22 = false), (menu2to = false), dayCustom()"></v-date-picker>
                    </v-col>
                  </v-row>
                </v-card>
              </v-menu>

              <v-autocomplete color="#fb8c00" @change="statusChange()" dense v-model="status" class="mr-4 rounded-lg" :items="statusOptions" hide-details :disabled="mainloader" style="min-width: 160px" label="Status filter" single-line>
                <template #append>
                  <v-icon @click="status ? ((status = null), statusChange()) : null">{{ status ? "mdi-close" : "mdi-chevron-down" }}</v-icon>
                </template>
              </v-autocomplete>

              <v-autocomplete color="#fb8c00" @change="requestChange()" dense v-model="requestFilter" class="mr-4 rounded-lg" :items="requestTypeOptions" hide-details :disabled="mainloader" style="min-width: 130px" label="Request filter" single-line>
                <template #append>
                  <v-icon @click="requestFilter ? ((requestFilter = ''), requestChange()) : null">{{ requestFilter ? "mdi-close" : "mdi-chevron-down" }}</v-icon>
                </template>
              </v-autocomplete>

              <v-text-field color="#fb8c00" dense v-model="search" @input="onSearch" clearable @click:clear="onSearch" class="rounded-lg" style="max-width: 160px" prepend-inner-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>

              <v-btn v-if="dashboarddata.length > 0" icon :loading="mainloader" :disabled="mainloader" @click="tab == 1 ? downloadApprovedReport() : downloadFile('xls')"
                ><svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
                  <path
                    d="M11 1.26953V5.40007C11 5.96012 11 6.24015 11.109 6.45406C11.2049 6.64222 11.3578 6.7952 11.546 6.89108C11.7599 7.00007 12.0399 7.00007 12.6 7.00007H16.7305M6 14L9 17M9 17L12 14M9 17L9 11M11 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H12.2C13.8802 21 14.7202 21 15.362 20.673C15.9265 20.3854 16.3854 19.9265 16.673 19.362C17 18.7202 17 17.8802 17 16.2V7L11 1Z"
                    stroke="#fb8c00"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  /></svg></v-btn>

              <v-btn v-else icon :loading="mainloader" disabled
                ><svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
                  <path
                    d="M11 1.26953V5.40007C11 5.96012 11 6.24015 11.109 6.45406C11.2049 6.64222 11.3578 6.7952 11.546 6.89108C11.7599 7.00007 12.0399 7.00007 12.6 7.00007H16.7305M6 14L9 17M9 17L12 14M9 17L9 11M11 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H12.2C13.8802 21 14.7202 21 15.362 20.673C15.9265 20.3854 16.3854 19.9265 16.673 19.362C17 18.7202 17 17.8802 17 16.2V7L11 1Z"
                    stroke="#fb8c00"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  /></svg></v-btn>

              <v-btn icon :loading="mainloader" :disabled="mainloader" @click="getDashboard()"><v-icon color="#fb8c00">mdi-refresh</v-icon></v-btn>
            </v-toolbar>
            <v-divider></v-divider>
          </template>
          <template v-slot:[`item.date_time`]="{item}">
            <p class="mb-0" style="width: 120px">{{ item.date_time ? item.date_time.slice(0, 16) : item.date_time }}</p>
          </template>
          <template v-slot:[`item.approval_date_time`]="{item}">
            <p class="mb-0" style="width: 120px">{{ item.approval_date_time ? item.approval_date_time.slice(0, 16) : item.approval_date_time }}</p>
          </template>
          <template v-slot:[`item.rejection_date_time`]="{item}">
            <p class="mb-0" style="width: 120px">{{ item.rejection_date_time ? item.rejection_date_time.slice(0, 16) : item.rejection_date_time }}</p>
          </template>
          <template v-slot:[`item.e_signed_datetime`]="{item}">
            <p class="mb-0" style="width: 120px">{{ item.e_signed_datetime ? item.e_signed_datetime.slice(0, 16) : item.e_signed_datetime }}</p>
          </template>

          <template v-slot:[`item.app_status`]="{item}">
            <div v-if="tab == 2">
              <v-tooltip color="black" bottom>
                <template v-slot:activator="{on, attrs}">
                  <div v-bind="attrs" v-on="on">
                    <span>{{ item.app_status }}</span>
                  </div>
                </template>
                <span>{{ item.rejected_reason }}</span>
              </v-tooltip>
            </div>
            <div v-else>
                      <span>{{ item.retained_status == 'retained' ? item.retained_status : item.app_status }}</span>

            </div>
          </template>
          <template v-slot:[`item.KRA_view`]="{item}">
            <v-btn @click="setKRAvalidation(item)" small color="#2196F3" class="elevation-0 rounded-md" v-if="item.request == 'mobile' || item.request == 'email' || item.request == 'address'">
              <span class="white--text text-none">KRA valid</span>
            </v-btn>
          </template>
          <template v-slot:[`item.view`]="{item}">
            <v-btn small @click="getSingledata(item)" color="#0037B7" class="elevation-0 rounded-md">
              <span class="white--text text-none">{{ tab == 0 ? "Verify" : "View" }}</span>
            </v-btn>
          </template>
        </v-data-table>
        <div class="d-flex flex-column align-center px-4 py-2" v-if="showdata.length || totalPageCount > 1">
          <v-pagination v-model="page" :length="totalPageCount" :total-visible="9" circle :disabled="mainloader" @input="getDashboard()"></v-pagination>
        </div>
      </v-card>
    </v-container>
    <v-bottom-sheet class="btmsheetclass" v-model="btmsheet" hide-overlay persistent>
      <v-sheet class="text-center" height="100vh" style="position: relative">
        <!-- the page snackbar sits behind this sheet, so CDSL outcomes (and other sheet actions) must show here -->
        <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition" v-model="snackbar" timeout="5000" :value="true" :color="snackbarclr" absolute outlined top right>
          <v-icon class="mr-2" :color="snackbarclr">mdi-alert-outline</v-icon>
          {{ snackmsgbar }}
          <v-icon @click="snackbar = false" class="float-right" :color="snackbarclr">mdi-close-circle</v-icon>
        </v-snackbar>
        <v-toolbar dense flat>
          <img src="@/assets/Zebu Logo.svg" width="90px" />

          <v-spacer></v-spacer>
          <!-- Auto pushes straight away; Manual opens the confirmation modal (edit / Push) first. Never sent to the API -->
          <v-btn-toggle v-if="cdslEligible(btmdata) && !cdslBlockReason(btmdata)" :value="isCdslManual(btmdata) ? 'manual' : 'auto'" @change="setCdslMode($event)" mandatory dense borderless class="mode-pill mr-3">
            <v-btn small value="auto" :disabled="isCdslBusy(btmdata)" :title="cdslManualOnly(btmdata) ? 'Response failed - switch to Manual to push again' : ''" class="text-none">Auto</v-btn>
            <v-btn small value="manual" :disabled="isCdslBusy(btmdata)" class="text-none">Manual</v-btn>
          </v-btn-toggle>
          <v-chip v-if="isCdslType(btmdata) && (btmdata.cdsl_status || cdslEligible(btmdata))" small label outlined :color="cdslChipColor(btmdata)" class="mr-2 font-weight-bold" :title="cdslBlockReason(btmdata) || cdslEditReason(btmdata)"><v-progress-circular v-if="cdslStatus(btmdata) == 'PROCESSING'" indeterminate size="12" width="2" class="mr-1"></v-progress-circular>CDSL: {{ cdslStatusText(btmdata) }}</v-chip>
          <v-btn v-if="btmdata.vno || canMarkJvPassed(btmdata)" small color="#FF1717" class="elevation-0 rounded-lg mr-2" :loading="jvbtn" :disabled="jvbtn || !!btmdata.vno" @click="openJvDialog(btmdata)">
            <span class="text-none" :class="btmdata.vno ? '' : 'white--text'">JV Already Passed</span>
          </v-btn>
          <v-btn icon :loading="mainloader" @click="downloadFile('single')">
            <v-icon>mdi-download</v-icon>
          </v-btn>
          <v-btn icon :disabled="mainloader" @click="getSingledata(btmdata)">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-btn icon @click="btmsheet = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <div class="py-3 px-3">
          <v-row no-glutters style="border-bottom: thin solid #2a2a2a30">
            <v-col cols="4" class="pa-0">
              <v-tabs v-model="btmltab" show-arrows @change="btmltab == 4 ? (btmrtab = 1) : btmltab == 5 ? (btmrtab = 2) : btmltab == 6 ? (btmrtab = 3) : btmltab == 7 ? (btmrtab = 4) : btmltab == 8 ? (btmrtab = 5) : (btmrtab = 0)">
                <v-tab class="text-none">Client</v-tab>
                <v-tab class="text-none" :disabled="btmdata.request != 'nominee'">Nominee</v-tab>
                <v-tab class="text-none" :disabled="btmdata.request != 'email'">Email</v-tab>
                <v-tab class="text-none" :disabled="btmdata.request != 'mobile'">Mobile</v-tab>
                <v-tab class="text-none" :disabled="btmdata.request != 'address'">Address</v-tab>
                <v-tab class="text-none" :disabled="btmdata.request != 'bank'">Bank</v-tab>
                <v-tab class="text-none" :disabled="btmdata.request != 'income'">Income</v-tab>
                <v-tab class="text-none" :disabled="btmdata.request != 'segment'">Segment</v-tab>
                <v-tab class="text-none" :disabled="btmdata.request != 'closure'">Closure</v-tab>
              </v-tabs>
            </v-col>
            <v-col cols="8" class="pa-0">
              <v-tabs v-model="btmrtab" @change="btmrtab == 1 ? (btmltab = 4) : btmrtab == 2 ? (btmltab = 5) : btmrtab == 3 ? (btmltab = 6) : btmrtab == 4 ? (btmltab = 7) : btmrtab == 5 ? (btmltab = 8) : (btmltab = 0)">
                <v-tab class="text-none" :disabled="btmdata.request == 'income' || btmdata.request == 'closure'">e-sign document</v-tab>
                <v-tab class="text-none" :disabled="btmdata.request != 'address'">Address proof</v-tab>
                <v-tab class="text-none" :disabled="btmdata.request != 'bank'">Bank proof</v-tab>
                <v-tab class="text-none" :disabled="btmdata.request != 'income'">Income proof</v-tab>
                <v-tab class="text-none" :disabled="btmdata.request != 'segment'">Segment proof</v-tab>
                <v-tab class="text-none" :disabled="btmdata.request != 'closure'">Closure form</v-tab>
                <v-tab class="text-none" :disabled="btmdata.request != 'address' && btmdata.request != 'mobile' && btmdata.request != 'email'">KRA form</v-tab>
                <v-tab class="text-none" :disabled="btmdata.request != 'address'">Aadhar XML</v-tab>
              </v-tabs>
            </v-col>
          </v-row>
          <v-row no-glutters>
            <v-col cols="4" style="height: calc(100vh - 140px); overflow: scroll; border-right: thin solid #2a2a2a30">
              <div v-if="btmltab == 0" class="text-left">
                <p class="grey--text mb-0">Name</p>
                <p class="black--text font-weight-bold">{{ btmdata.client_name ? btmdata.client_name : "-" }}</p>
                <p class="grey--text mb-0">Client ID</p>
                <p class="black--text font-weight-bold">{{ btmdata.client_id ? btmdata.client_id : "-" }}</p>
                <p class="grey--text mb-0">DP code</p>
                <p class="black--text font-weight-bold">{{ btmdata.dp_code ? btmdata.dp_code : "-" }}</p>
                <p class="grey--text mb-0">Email</p>
                <p class="black--text font-weight-bold">{{ btmdata.client_email ? btmdata.client_email : "-" }}</p>
                <p class="grey--text mb-0">PAN</p>
                <p class="black--text font-weight-bold">{{ btmdata.client_pan ? btmdata.client_pan : "-" }}</p>
                <p class="grey--text mb-0">Request status</p>
                <p class="black--text font-weight-bold">{{ btmdata.request ? btmdata.request : "-" }}</p>
                <p class="grey--text mb-0">Application status</p>
                <p class="black--text font-weight-bold">{{ btmdata.app_status ? btmdata.app_status : "-" }}</p>
                         <div >
              
                     <p class="grey--text mb-0">Branch ID</p>
                
                <p class="black--text font-weight-bold">{{ btmdata.branch_id ? btmdata.branch_id  : "---" }}</p>
                                   <p class="grey--text mb-0">Branch Email</p>
                <div v-if="btmdata.request == 'closure'">         
                <p class="black--text font-weight-bold">{{ btmdata.branch_email_id ? btmdata.branch_email_id  : "---" }}</p>
                </div>
                <div v-if="btmdata.request != 'closure'">
                <p class="black--text font-weight-bold">{{ btmdata.branch_email ? btmdata.branch_email  : "---" }}</p>
                </div>
                  <p class="grey--text mb-0">Branch Mail status</p>
                <p class="black--text font-weight-bold">{{ btmdata.mail_send_status ? btmdata.mail_send_status == '1' ? 'Mail Sended' : 'Mail Not Send'  : '---'}}</p>
                  <div class="mt-3 mb-3" v-if="canSendBranchMail">
                     <p class="grey--text mb-0">Send Mail To Branch</p>
                  <v-btn  :loading="closbtnload" @click="clossendmailapi()" rounded dense color="primary" class="mt-2 text-none" elevation="0">
                  Send Mail
                  </v-btn>
                </div>
                <div >
                      <p class="grey--text mb-0">Branch Status</p>
                <p class="black--text font-weight-bold">{{ btmdata.branch_status ? btmdata.branch_status == 'rejected' ? 'Retained' :  btmdata.branch_status : "---" }}</p>          
                 <p class="grey--text mb-0">Branch Feedback</p>
                <p class="black--text font-weight-bold">{{ btmdata.branch_feedback ? btmdata.branch_feedback  : "---" }}</p>
                </div>
                <div v-if="btmdata.request == 'closure'">
                    <p class="grey--text mb-0">Branch Update Date & Time</p>
                <p class="black--text font-weight-bold">{{ btmdata.branch_status_datetime ? btmdata.branch_status_datetime  : "---" }}</p>
                </div>
                <div >
                   <p class="grey--text mb-0">Branch Date & Time</p>
                <p class="black--text font-weight-bold">{{ btmdata.branch_datetime ? btmdata.branch_datetime  : "---" }}</p>
                </div>
          </div> 
              </div>
              <div v-if="btmltab == 1" class="text-left">
                <v-expansion-panels class="elevation-0">
                  <v-expansion-panel class="exp-sty">
                    <v-expansion-panel-header class="px-0" :class="btmdata.nominee1_name ? (btmdata.nominee1_name.length > 0 ? 'font-weight-bold' : 'font-weight-regular') : ''">1st Nominee </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-0 text-left">
                      <p class="grey--text mb-0">Nominee name</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee1_name ? btmdata.nominee1_name : "-" }}</p>
                      <p class="grey--text mb-0">Nominee relation</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee1_relation ? btmdata.nominee1_relation : "-" }}</p>
                      <p class="grey--text mb-0">Nominee percentage</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee1_percentage ? btmdata.nominee1_percentage : "-" }}</p>
                      <p class="grey--text mb-0">Nominee DOB</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee1_DOB ? btmdata.nominee1_DOB : "-" }}</p>
                      <p class="grey--text mb-0">Nominee address</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee1_address1 ? btmdata.nominee1_address1 : "-" }}</p>
                      <p class="grey--text mb-0">Nominee city</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee1_city ? btmdata.nominee1_city : "-" }}</p>
                      <p class="grey--text mb-0">Nominee pincode</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee1_pincode ? btmdata.nominee1_pincode : "-" }}</p>
                      <p class="grey--text mb-0">Nominee state</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee1_state ? btmdata.nominee1_state : "-" }}</p>
                      <p class="grey--text mb-0">Nominee country</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee1_country ? btmdata.nominee1_country : "-" }}</p>
                      <p class="grey--text mb-0">Nominee email</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee1_email ? btmdata.nominee1_email : "-" }}</p>
                      <p class="grey--text mb-0">Nominee mobile</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee1_mobile ? btmdata.nominee1_mobile : "-" }}</p>
                      <p class="grey--text mb-0">guardian name</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_name ? btmdata.guardian_name : "-" }}</p>
                      <p class="grey--text mb-0">guardian relation</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_relation ? btmdata.guardian_relation : "-" }}</p>
                      <p class="grey--text mb-0">guardian DOB</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_dob ? btmdata.guardian_dob : "-" }}</p>
                      <p class="grey--text mb-0">guardian address</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_address ? btmdata.guardian_address : "-" }}</p>
                      <p class="grey--text mb-0">guardian city</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_city ? btmdata.guardian_city : "-" }}</p>
                      <p class="grey--text mb-0">guardian state</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_state ? btmdata.guardian_state : "-" }}</p>
                      <p class="grey--text mb-0">guardian pincode</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_pincode ? btmdata.guardian_pincode : "-" }}</p>
                      <p class="grey--text mb-0">guardian country</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_country ? btmdata.guardian_country : "-" }}</p>
                      <p class="grey--text mb-0">guardian email</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_email ? btmdata.guardian_email : "-" }}</p>
                      <p class="grey--text mb-0">guardian mobile</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_mobile ? btmdata.guardian_mobile : "-" }}</p>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel class="exp-sty" :class="btmdata.nominee2_name ? (btmdata.nominee2_name.length > 0 ? 'font-weight-bold' : 'font-weight-regular') : ''">
                    <v-expansion-panel-header class="px-0">2nd Nominee </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-0 text-left">
                      <p class="grey--text mb-0">Nominee name</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee2_name ? btmdata.nominee2_name : "-" }}</p>
                      <p class="grey--text mb-0">Nominee relation</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee2_relation ? btmdata.nominee2_relation : "-" }}</p>
                      <p class="grey--text mb-0">Nominee percentage</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee2_percentage ? btmdata.nominee2_percentage : "-" }}</p>
                      <p class="grey--text mb-0">Nominee DOB</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee2_DOB ? btmdata.nominee2_DOB : "-" }}</p>
                      <p class="grey--text mb-0">Nominee address</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee2_address1 ? btmdata.nominee2_address1 : "-" }}</p>
                      <p class="grey--text mb-0">Nominee city</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee2_city ? btmdata.nominee2_city : "-" }}</p>
                      <p class="grey--text mb-0">Nominee pincode</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee2_pincode ? btmdata.nominee2_pincode : "-" }}</p>
                      <p class="grey--text mb-0">Nominee state</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee2_state ? btmdata.nominee2_state : "-" }}</p>
                      <p class="grey--text mb-0">Nominee country</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee2_country ? btmdata.nominee2_country : "-" }}</p>
                      <p class="grey--text mb-0">Nominee email</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee2_email ? btmdata.nominee2_email : "-" }}</p>
                      <p class="grey--text mb-0">Nominee mobile</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee2_mobile ? btmdata.nominee2_mobile : "-" }}</p>
                      <p class="grey--text mb-0">guardian name</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_name2 ? btmdata.guardian_name2 : "-" }}</p>
                      <p class="grey--text mb-0">guardian relation</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_relation2 ? btmdata.guardian_relation2 : "-" }}</p>
                      <p class="grey--text mb-0">guardian DOB</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_dob2 ? btmdata.guardian_dob2 : "-" }}</p>
                      <p class="grey--text mb-0">guardian address</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_address2 ? btmdata.guardian_address2 : "-" }}</p>
                      <p class="grey--text mb-0">guardian city</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_city2 ? btmdata.guardian_city2 : "-" }}</p>
                      <p class="grey--text mb-0">guardian state</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_state2 ? btmdata.guardian_state2 : "-" }}</p>
                      <p class="grey--text mb-0">guardian pincode</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_pincode2 ? btmdata.guardian_pincode2 : "-" }}</p>
                      <p class="grey--text mb-0">guardian country</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_country2 ? btmdata.guardian_country2 : "-" }}</p>
                      <p class="grey--text mb-0">guardian email</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_email2 ? btmdata.guardian_email2 : "-" }}</p>
                      <p class="grey--text mb-0">guardian mobile</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_mobile2 ? btmdata.guardian_mobile2 : "-" }}</p>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel class="exp-sty" :class="btmdata.nominee3_name ? (btmdata.nominee3_name.length > 0 ? 'font-weight-bold' : 'font-weight-regular') : ''">
                    <v-expansion-panel-header class="px-0">3rd Nominee </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-0 text-left">
                      <p class="grey--text mb-0">Nominee name</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee3_name ? btmdata.nominee3_name : "-" }}</p>
                      <p class="grey--text mb-0">Nominee relation</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee3_relation ? btmdata.nominee3_relation : "-" }}</p>
                      <p class="grey--text mb-0">Nominee percentage</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee3_percentage ? btmdata.nominee3_percentage : "-" }}</p>
                      <p class="grey--text mb-0">Nominee DOB</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee3_DOB ? btmdata.nominee3_DOB : "-" }}</p>
                      <p class="grey--text mb-0">Nominee address</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee3_address1 ? btmdata.nominee3_address1 : "-" }}</p>
                      <p class="grey--text mb-0">Nominee city</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee3_city ? btmdata.nominee3_city : "-" }}</p>
                      <p class="grey--text mb-0">Nominee pincode</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee3_pincode ? btmdata.nominee3_pincode : "-" }}</p>
                      <p class="grey--text mb-0">Nominee state</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee3_state ? btmdata.nominee3_state : "-" }}</p>
                      <p class="grey--text mb-0">Nominee country</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee3_country ? btmdata.nominee3_country : "-" }}</p>
                      <p class="grey--text mb-0">Nominee email</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee3_email ? btmdata.nominee3_email : "-" }}</p>
                      <p class="grey--text mb-0">Nominee mobile</p>
                      <p class="black--text font-weight-bold">{{ btmdata.nominee3_mobile ? btmdata.nominee3_mobile : "-" }}</p>
                      <p class="grey--text mb-0">guardian name</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_name3 ? btmdata.guardian_name3 : "-" }}</p>
                      <p class="grey--text mb-0">guardian relation</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_relation3 ? btmdata.guardian_relation3 : "-" }}</p>
                      <p class="grey--text mb-0">guardian DOB</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_dob3 ? btmdata.guardian_dob3 : "-" }}</p>
                      <p class="grey--text mb-0">guardian address</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_address3 ? btmdata.guardian_address3 : "-" }}</p>
                      <p class="grey--text mb-0">guardian city</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_city3 ? btmdata.guardian_city3 : "-" }}</p>
                      <p class="grey--text mb-0">guardian state</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_state3 ? btmdata.guardian_state3 : "-" }}</p>
                      <p class="grey--text mb-0">guardian pincode</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_pincode3 ? btmdata.guardian_pincode3 : "-" }}</p>
                      <p class="grey--text mb-0">guardian country</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_country3 ? btmdata.guardian_country3 : "-" }}</p>
                      <p class="grey--text mb-0">guardian email</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_email3 ? btmdata.guardian_email3 : "-" }}</p>
                      <p class="grey--text mb-0">guardian mobile</p>
                      <p class="black--text font-weight-bold">{{ btmdata.guardian_mobile3 ? btmdata.guardian_mobile3 : "-" }}</p>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
              <div v-if="btmltab == 2" class="text-left">
                <p class="grey--text mb-0">Existing email ID</p>
                <p class="black--text font-weight-bold">{{ btmdata.client_email ? btmdata.client_email : "-" }}</p>
                <p class="grey--text mb-0">New email ID</p>
                <p class="black--text font-weight-bold">{{ btmdata.new_email_id ? btmdata.new_email_id : "-" }}</p>
              </div>
              <div v-if="btmltab == 3" class="text-left">
                <p class="grey--text mb-0">Existing mobile no</p>
                <p class="black--text font-weight-bold">{{ btmdata.existing_mobile_number ? btmdata.existing_mobile_number : "-" }}</p>
                <p class="grey--text mb-0">New mobile no</p>
                <p class="black--text font-weight-bold">{{ btmdata.new_mobile_number ? btmdata.new_mobile_number : "-" }}</p>
              </div>
              <div v-if="btmltab == 4" class="text-left">
                <p class="grey--text mb-0">Existing address</p>
                <p class="black--text font-weight-bold">{{ btmdata.ext_address ? btmdata.ext_address : "-" }}</p>
                <p class="grey--text mb-0">New address</p>
                <p class="black--text font-weight-bold">{{ btmdata.cur_address ? btmdata.cur_address : "-" }}</p>
              </div>
              <div v-if="btmltab == 5" class="text-left">
                <p class="grey--text mb-0">Client's request</p>
                <p class="black--text font-weight-bold">{{ bankOptionText(btmdata) }}</p>
                <v-divider class="mb-3"></v-divider>
                <p class="grey--text">Existing bank details</p>
                <div class="pl-4">
                  <p class="grey--text mb-0">Account Number</p>
                  <p class="black--text font-weight-bold">{{ btmdata.exists_bank_account ? btmdata.exists_bank_account.acc_no : "-" }}</p>
                  <p class="grey--text mb-0">IFSC</p>
                  <p class="black--text font-weight-bold">{{ btmdata.exists_bank_account ? btmdata.exists_bank_account.ifsc_no : "-" }}</p>
                </div>
                <v-divider class="mb-3"></v-divider>
                <p class="grey--text">New bank details</p>
                <div class="pl-4">
                  <p class="grey--text mb-0">Account Number</p>
                  <p class="black--text font-weight-bold">{{ btmdata.BankAccountNumber ? btmdata.BankAccountNumber : "-" }}</p>
                  <p class="grey--text mb-0">IFSC</p>
                  <p class="black--text font-weight-bold">{{ btmdata.IFSC ? btmdata.IFSC : "-" }}</p>
                  <p class="grey--text mb-0">MICR</p>
                  <p class="black--text font-weight-bold">{{ btmdata.MICR ? btmdata.MICR : "-" }}</p>
                  <p class="grey--text mb-0">Account type</p>
                  <p class="black--text font-weight-bold">{{ btmdata.bank_account_type ? btmdata.bank_account_type : "-" }}</p>
                  <template v-if="String(btmdata.option || '').toLowerCase() != 'delete'">
                    <p class="grey--text mb-0">Primary bank account</p>
                    <p class="black--text font-weight-bold">{{ bankDefaultText(btmdata) }}</p>
                  </template>
                  <p class="grey--text mb-0">BankName</p>
                  <p class="black--text font-weight-bold">{{ btmdata.BankName ? btmdata.BankName : "-" }}</p>
                  <p class="grey--text mb-0">Branch Name</p>
                  <p class="black--text font-weight-bold">{{ btmdata.BranchName ? btmdata.BranchName : "-" }}</p>
                  <p class="grey--text mb-0">Bank Address</p>
                  <p class="black--text font-weight-bold">{{ btmdata.BankAddress ? btmdata.BankAddress : "-" }}</p>

                     <p class="grey--text mb-0">Penny drop Name</p>
                  <p class="black--text font-weight-bold">{{ btmdata.reg_name ? btmdata.reg_name : "-" }}</p>

                  <p class="grey--text mb-0">Penny drop verify</p>
                  <p class="black--text font-weight-bold">{{ btmdata.peenydropVerify ? btmdata.peenydropVerify : "-" }}</p>
                  <p class="grey--text mb-0">Penny drop verify time</p>
                  <p class="black--text font-weight-bold">{{ btmdata.peenydropVerifyTime ? btmdata.peenydropVerifyTime : "-" }}</p>

                  <v-btn :loading="bakchekload" elevation="0" @click="checdatafun(btmdata)" color="primary" v-if="  btmdata.peenydropVerify == ''  && btmdata.option == 'add' && (btmdata.app_status == 'e-signed completed' || btmdata.app_status == 'approved')   ">
Fetch Penny Drop Status
                  </v-btn>
                </div>
              </div>
              <div v-if="btmltab == 6" class="text-left">
                <p class="grey--text mb-0">Existing income slab</p>
                <p class="black--text font-weight-bold">{{ btmdata.ext_income_range ? btmdata.ext_income_range : "-" }}</p>
                <p class="grey--text mb-0">New income slab</p>
                <p class="black--text font-weight-bold">{{ btmdata.cur_income_range ? btmdata.cur_income_range : "-" }}</p>
              </div>
              <div v-if="btmltab == 7" class="text-left">
                <p class="grey--text mb-0">Adding segments</p>
                <p class="black--text font-weight-bold">{{ btmdata.adding_segments ? btmdata.adding_segments : "-" }}</p>
                <p class="grey--text mb-0">Re-active segments</p>
                <p class="black--text font-weight-bold">{{ btmdata.re_active_segments ? btmdata.re_active_segments : "-" }}</p>

                <p class="grey--text mb-0">Existing active segments</p>
                <v-chip-group v-if="btmdata.ext_segements" column class="mb-3">
                  <v-chip class="black--text font-weight-bold" small v-for="(l, k) in btmdata.ext_segements" :key="k">
                    {{ l }}
                  </v-chip>
                </v-chip-group>
                <p class="black--text font-weight-bold" v-else>-</p>

                <p class="grey--text mb-0">New active segments</p>
                <v-chip-group v-if="btmdata.new_segments" column>
                  <v-chip class="black--text font-weight-bold" small v-for="(l, k) in btmdata.new_segments" :key="k">
                    {{ l }}
                  </v-chip>
                </v-chip-group>
                <p class="black--text font-weight-bold" v-else>-</p>
              </div>
              <div v-if="btmltab == 8" class="text-left">
                <p class="grey--text mb-0">Request status</p>
                <p class="black--text font-weight-bold">{{ btmdata.request ? btmdata.request : "-" }}</p>
                <p class="grey--text mb-0">Initiated Date & Time</p>
                <p class="black--text font-weight-bold">{{ btmdata.date_time ? btmdata.date_time : "-" }}</p>
                    <p class="grey--text mb-0">E-signed Date & Time:</p>
                <p class="black--text font-weight-bold">{{ btmdata.e_signed_datetime ? btmdata.e_signed_datetime : "-" }}</p>
                <p class="grey--text mb-0">Reason</p>
                <p class="black--text font-weight-bold">{{ btmdata.reason ? btmdata.reason : "-" }}</p>
                <p class="grey--text mb-0">Client ID</p>
                <p class="black--text font-weight-bold">{{ btmdata.client_id ? btmdata.client_id : "-" }}</p>
                <p class="grey--text mb-0">DP code</p>
                <p class="black--text font-weight-bold">{{ btmdata.dp_code ? btmdata.dp_code : "-" }}</p>
                <p class="grey--text mb-0">Application status</p>
                <p class="black--text font-weight-bold">{{ btmdata.app_status ? btmdata.app_status : "-" }}</p>
        
             </div>
            </v-col>
            <v-col cols="8" style="height: calc(100vh - 140px); overflow: scroll" class="pa-0">
              <v-tabs-items v-model="btmrtab">
                <v-tab-item>
                  <iframe style="border: none; border-radius: 0" :src="btmdata.e_signed_pdf_path ? btmdata.e_signed_pdf_path : ''" width="100%" height="800px"></iframe>
                </v-tab-item>
                <v-tab-item>
                  <iframe style="border: none; border-radius: 0" :src="btmdata.proff_path ? btmdata.proff_path : ''" width="100%" height="800px"></iframe>
                </v-tab-item>
                <v-tab-item>
                  <iframe style="border: none; border-radius: 0" :src="btmdata.proff_path ? btmdata.proff_path : ''" width="100%" height="800px"></iframe>
                </v-tab-item>
                <v-tab-item>
                  <iframe v-if="btmdata.proff_path" style="border: none; border-radius: 0" :src="btmdata.proff_path ? btmdata.proff_path : ''" width="100%" height="800px"></iframe>
                  <div v-else class="py-16">New income slab is below 25Lakhs, Income proof & e-sign documents are not required.</div>
                </v-tab-item>
                <v-tab-item>
                  <iframe v-if="btmdata.proff_path" style="border: none; border-radius: 0" :src="btmdata.proff_path ? btmdata.proff_path : ''" width="100%" height="800px"></iframe>
                  <div v-else class="py-16">Only for derivatives segments; segment proof is required.</div>
                </v-tab-item>
                <v-tab-item>
                  <iframe v-if="btmdata.e_signed_pdf_path_1" style="border: none; border-radius: 0" :src="btmdata.e_signed_pdf_path_1 ? btmdata.e_signed_pdf_path_1 : ''" width="50%" height="800px"></iframe>
                  <iframe v-if="btmdata.e_signed_pdf_path_2" style="border: none; border-radius: 0" :src="btmdata.e_signed_pdf_path_2 ? btmdata.e_signed_pdf_path_2 : ''" width="50%" height="800px"></iframe>
                </v-tab-item>
                <v-tab-item>
                  <iframe style="border: none; border-radius: 0" :src="btmdata.kra_file_path ? btmdata.kra_file_path : ''" width="100%" height="800px"></iframe>
                </v-tab-item>
                <v-tab-item class="py-16">
                  <v-btn v-if="btmdata.request == 'address'" class="text-none my-4 elevation-0" target="_blank" :disabled="btmdata.aadharxmlfile ? false : true" :href="btmdata.aadharxmlfile">Download Aadhar XML</v-btn>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </div>
        <div v-if="this.tab == 0">
        <v-footer v-if="(btmdata.app_status != 'approved' && btmdata.app_status != 'rejected' && btmltab != 0) || btmdata.request == 'DDPI' || btmdata.request == 'mtf'" style="position: absolute; width: 100%; bottom: 0">
          <!-- one right-aligned action bar: CDSL actions grouped in their own panel, then a divider, then the decision buttons -->
          <div class="d-flex align-center justify-end px-1" style="width: 100%">
            <!-- pushing to CDSL does not approve the request; Complete is still clicked separately -->
            <template v-if="cdslEligible(btmdata)">
              <div class="d-inline-flex align-center rounded-lg" style="border: thin solid #3f51b540; background: #ffffff; padding: 3px">
                <span class="caption font-weight-bold px-2" style="color: #3f51b5; letter-spacing: 0.08em">CDSL</span>
                <!-- the Auto / Manual toggle in the toolbar decides what Push does; only its label follows the mode -->
                <!-- disabled buttons get no hover events, so the "why" tooltip hangs off a wrapper -->
                <v-tooltip top :disabled="!cdslBlockReason(btmdata)">
                  <template v-slot:activator="{on, attrs}">
                    <span v-bind="attrs" v-on="on" class="d-inline-flex mr-2">
                      <v-btn @click="isCdslManual(btmdata) ? getCdslPreview(btmdata) : setCdslPush(btmdata)" :disabled="!canCdslPush(btmdata) || isCdslBusy(btmdata)" :loading="isCdslBusy(btmdata, 'push')" color="#3F51B5" class="elevation-0 rounded-lg">
                        <span class="white--text text-none">{{ isCdslManual(btmdata) ? "Manual Push" : "Auto Push" }}</span>
                      </v-btn>
                    </span>
                  </template>
                  <span>Can't update in CDSL - {{ cdslBlockReason(btmdata) }}</span>
                </v-tooltip>
                <v-btn @click="setCdslStatusCheck(btmdata)" :disabled="!canCdslResponse(btmdata) || isCdslBusy(btmdata)" :loading="isCdslBusy(btmdata, 'res')" color="#3F51B5" class="elevation-0 rounded-lg">
                  <span class="white--text text-none">Response</span>
                </v-btn>
                <!-- occasional actions live in one menu so the panel keeps just the main flow (Push / Response) -->
                <v-menu top offset-y left>
                  <template v-slot:activator="{on, attrs}">
                    <v-btn v-bind="attrs" v-on="on" :disabled="isCdslBusy(btmdata) || !!cdslBlockReason(btmdata)" :loading="isCdslBusy(btmdata, 'download') || isCdslBusy(btmdata, 'regen') || isCdslBusy(btmdata, 'skip')" color="#3F51B5" class="elevation-0 rounded-lg ml-2">
                      <span class="white--text text-none">More</span>
                      <v-icon right color="white">mdi-menu-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <!-- BO Modify file for manual CDAS upload / reference; neither option pushes to CDSL -->
                    <v-list-item  @click="getCdslZip(btmdata)">
                      <v-list-item-content>
                        <v-list-item-title>Download file</v-list-item-title>
                        <v-list-item-subtitle>{{ cdslFilePath(btmdata) ? "Saved file" : "Generates the file first" }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if="cdslFilePath(btmdata)" @click="regenerateCdslZip(btmdata)">
                      <v-list-item-content>
                        <v-list-item-title>Regenerate file</v-list-item-title>
                        <v-list-item-subtitle>New file, uses a new serial number</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <!-- records "deliberately not sent to CDSL"; nothing is uploaded or generated, and Push stays available -->
                    <template v-if="canCdslSkip(btmdata)">
                      <v-divider class="my-1"></v-divider>
                      <v-list-item @click="openCdslSkip(btmdata)">
                        <v-list-item-content>
                          <v-list-item-title>Skip CDSL</v-list-item-title>
                          <v-list-item-subtitle>Mark as not sent to CDSL</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-menu>
              </div>
              <v-divider vertical class="mx-4 my-1"></v-divider>
            </template>
            <v-btn @click="bfoRejection(), (rejdialog = true)" color="#FF1717" class="elevation-0 rounded-lg mr-4">
              <span class="white--text text-none">Reject</span>
            </v-btn>
            <v-btn v-if="btmdata.request == 'closure'" @click="retainedfun()" color="orange" class="elevation-0 rounded-lg mr-4">
              <span class="white--text text-none">Retained</span>
            </v-btn>
            <v-tooltip top :disabled="!cdslBlocksComplete(btmdata)">
              <template v-slot:activator="{on, attrs}">
                <span v-bind="attrs" v-on="on" class="d-inline-flex">
                  <v-btn @click="comdialog = true" :disabled="completebtn || cdslBlocksComplete(btmdata)" :loading="completebtn" color="#43A833" class="elevation-0 rounded-lg">
                    <span class="white--text text-none">Complete</span>
                  </v-btn>
                </span>
              </template>
              <span>Enabled once CDSL accepts this request, the file is generated manually, CDSL is skipped, or the response check fails (CDSL: {{ cdslStatusText(btmdata) }})</span>
            </v-tooltip>
          </div>
        </v-footer>
        </div>
      </v-sheet>
    </v-bottom-sheet>
    <v-dialog persistent v-model="cdslskipdialog" max-width="420">
      <v-card class="rounded-xl">
        <v-toolbar dense flat>
          <p class="mb-0 font-weight-bold">Skip CDSL for this request?</p>
          <v-spacer></v-spacer>
          <v-btn icon :disabled="isCdslBusy(cdslskipitem, 'skip')" @click="cdslskipdialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="pa-4">
          <p class="body-2 mb-4">
            This records that <b>{{ cdslskipitem.client_id }}</b>'s <b>{{ cdslskipitem.request }}</b> request will not be sent to CDSL.
          </p>
          <v-text-field v-model="cdslskipreason" label="Reason (optional)" class="rounded-lg" outlined dense hide-details></v-text-field>
          <div class="d-flex justify-end mt-4">
            <v-btn :disabled="isCdslBusy(cdslskipitem, 'skip')" @click="cdslskipdialog = false" class="elevation-0 rounded-lg mr-3">
              <span class="text-none">Cancel</span>
            </v-btn>
            <v-btn :loading="isCdslBusy(cdslskipitem, 'skip')" @click="setCdslSkip()" color="#607D8B" class="elevation-0 rounded-lg">
              <span class="white--text text-none">Skip</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="rejdialog" max-width="400">
      <v-card class="rounded-xl">
        <v-toolbar dense flat>
          <p class="mb-0 font-weight-bold">Enter the rejection reason</p>
          <v-spacer></v-spacer>
          <v-btn icon @click="rejdialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="pa-4">
          <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="setReject()">
            <v-text-field required :rules="[(v) => !!v || 'Reason is required']" v-model="rejectreason" label="Reject reason" class="rounded-lg" outlined clearable></v-text-field>

            <v-btn :disabled="!valid" type="submit" :loading="rejbtn" block color="#FF1717" large class="elevation-0 rounded-lg mb-4">
              <span class="white--text text-none">Reject this request</span>
            </v-btn>
          </v-form>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="comdialog" max-width="400">
      <v-card class="rounded-xl">
        <v-toolbar dense flat>
          <p class="mb-0 font-weight-bold">Request completion confirmation</p>
          <v-spacer></v-spacer>
          <v-btn :disabled="completebtn" icon @click="comdialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="pa-4">
          <!-- <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="setReject()">
            <v-text-field required :rules="[v => !!v || 'Reason is required']" v-model="rejectreason"
              label="Reject reason" class="rounded-lg" outlined clearable></v-text-field>

            <v-btn :disabled="!valid" type="submit" :loading="rejbtn" block color="#FF1717" large
              class="elevation-0 rounded-lg mb-4">
              <span class="white--text text-none">Reject this request</span>
            </v-btn>
          </v-form> -->
          <p class="mb-8">
            Are you sure the <b>{{ btmdata.client_id }}</b> confirmation for completion request for <b>{{ btmdata.request }}</b> ?
          </p>
          <v-row no-glutters>
            <v-col cols="6">
              <v-btn @click="comdialog = false" block :disabled="completebtn" color="#eeeeee" class="elevation-0 rounded-lg">
                <span class="text-none">Cancel</span>
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn @click="setComplete()" block :disabled="completebtn" :loading="completebtn" color="#43A833" class="elevation-0 rounded-lg">
                <span class="white--text text-none">Yes</span>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="kradialog" max-width="700">
      <v-card class="rounded-xl overflow-hidden">
        <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition" v-model="snackbar" timeout="5000" :value="true" :color="snackbarclr" absolute outlined top right>
          <v-icon class="mr-2" :color="snackbarclr">mdi-alert-outline</v-icon>
          {{ snackmsgbar }}
          <v-icon @click="snackbar = false" class="float-right" :color="snackbarclr">mdi-close-circle</v-icon>
        </v-snackbar>
        <v-toolbar dense flat>
          <p class="mb-0 font-weight-bold">KRA setup</p>
          <v-spacer></v-spacer>
          <v-btn :disabled="delbtn" icon @click="(kradialog = false), (btmdata = [])">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div>
          <v-row class="mb-0 px-4" no-glutters>
            <v-col cols="3" class="pb-1">
              <v-text-field :value="btmdata.client_id" hide-details dense readonly label="Client ID" class="rounded-lg" outlined></v-text-field>
            </v-col>
            <v-col cols="4" class="pb-1">
              <v-text-field :value="btmdata.client_pan" hide-details dense readonly label="PAN" class="rounded-lg" outlined></v-text-field>
            </v-col>
            <v-col cols="5" class="pb-1">
              <v-text-field :value="btmdata.client_name" hide-details dense readonly label="Name" class="rounded-lg" outlined></v-text-field>
            </v-col>
          </v-row>
          <v-stepper v-model="el" class="elevation-0">
            <v-stepper-header dense height="40px">
              <v-stepper-step class="px-3 py-2" :complete="el > 1" step="1"> Validation </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step class="px-3 py-2" :complete="el > 2" step="2"> Upload </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step class="px-3 py-2" step="3"> Completed </v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content step="1" class="py-2 px-3">
                <v-row no-glutters class="mt-0">
                  <v-col cols="6">
                    <p class="black--text font-weight-regular caption mb-0">
                      <v-chip color="red lighten-5" x-small class="elevation-0 pa-2"></v-chip> KRA values <v-btn color="red lighten-5" @click="setKRAfiledchanges('all', 1)" class="text-none px-1 elevation-1" x-small>select all</v-btn> <span class="float-right">Accepting</span
                      ><v-chip color="green lighten-5" x-small class="elevation-0 pa-2 float-right"></v-chip>
                    </p>
                  </v-col>
                  <v-col cols="6">
                    <p class="black--text font-weight-regular caption mb-0">
                      <v-chip color="blue lighten-5" x-small class="elevation-0 pa-2"></v-chip> New values <v-btn color="blue lighten-5" @click="setKRAfiledchanges('all', 0)" class="text-none px-1 elevation-1" x-small>select all</v-btn> <span class="float-right">Accepting</span
                      ><v-chip color="green lighten-5" x-small class="elevation-0 pa-2 float-right"></v-chip>
                    </p>
                  </v-col>
                </v-row>
                <div class="py-3 overflow-y-auto overflow-x-hidden" style="height: 336px !important">
                  <div v-for="(s, m) in [cor_addr, per_addr, per_details]" :key="m">
                    <div v-if="s">
                      <div v-for="(n, l) in s" :key="l">
                        <p class="grey--text mb-0 caption">
                          {{ l ? l : "-" }} <span v-if="n[4] != null" :class="n[3] ? 'black--text' : 'primary--text'" class="font-weight-medium">{{ n[3] ? "" : ` ${n[4] == 0 ? " >>> Accept new" : " <<< Accept KRA"} change` }}</span>
                        </p>
                        <v-row no-glutters class="mb-0">
                          <v-col cols="6" class="pr-1">
                            <v-card @click="(n[4] = 1), setKRAfiledchanges(l, 1, n, m)" class="elevation-0 pa-1" :disabled="n[3] || (n[4] != null && n[4] != 0)" :color="!n[3] ? (n[4] == null ? 'red lighten-5' : n[4] == 1 ? 'green lighten-5' : 'red lighten-5') : 'none'">
                              <p class="black--text font-weight-bold subtitle-2 mb-0" :style="`height: ${n[4] == 1 ? '42px' : '22px'} !important`">{{ n ? n[1] : "-" }}</p>
                              <p v-if="!n[3] && n[4] != 1" class="black--text font-weight-regular caption text-right mb-0">Accept KRA changes</p>
                            </v-card>
                          </v-col>
                          <v-col cols="6" class="pl-1">
                            <v-card @click="(n[4] = 0), setKRAfiledchanges(l, 0, n, m)" class="elevation-0 pa-1" :disabled="n[3] || (n[4] != null && n[4] != 1)" :color="!n[3] ? (n[4] == null ? 'blue lighten-5' : n[4] == 0 ? 'green lighten-5' : 'blue lighten-5') : 'none'">
                              <p class="black--text font-weight-bold subtitle-2 mb-0" :style="`height: ${!n[3] && n[4] == 0 ? '42px' : '22px'} !important`">{{ n ? n[0] : "-" }}</p>
                              <p v-if="!n[3] && n[4] != 0" class="black--text font-weight-regular caption text-right mb-0">Accept new changes</p>
                            </v-card>
                          </v-col>
                        </v-row>
                        <v-divider class="mb-2"></v-divider>
                      </div>
                    </div>
                  </div>
                </div>
                <v-toolbar class="pt-1" flat>
                  <span class="caption font-weight-regular"
                    >KRA Provider: <b>{{ btmdata.reskra && btmdata.reskra.kra_status && btmdata.reskra.kra_status.app_kra ? btmdata.reskra.kra_status.app_kra : "-" }} | {{ btmdata ? (btmdata.mode ? "Modify" : "New") : "" }}</b> <br />
                    KRA status: <b>{{ btmdata.reskra && btmdata.reskra.kra_status && btmdata.reskra.kra_status.app_status_message ? btmdata.reskra.kra_status.app_status_message : "-" }}</b> <br />
                    KRA Update Status: <b>{{ btmdata.reskra && btmdata.reskra.kra_status && btmdata.reskra.kra_status.app_update_status_message ? btmdata.reskra.kra_status.app_update_status_message : "-" }}</b></span
                  >
                  <v-spacer></v-spacer>
                  <v-btn @click="setKRApushedit()" :disabled="btmdata.valid && btmdata.valid.length != 0" class="text-none elevation-0 rounded-lg white--text" :loading="delbtn" color="blue"> Push to KRA </v-btn>
                </v-toolbar>
              </v-stepper-content>

              <v-stepper-content step="2">
                <div class="overflow-y-auto overflow-x-hidden" style="height: 346px !important" v-if="btmdata.reskra && btmdata.reskra.kra_status">
                  <div v-for="(n, l) in btmdata.reskra.kra_status" :key="l">
                    <p class="grey--text mb-0">{{ l ? l : "-" }}</p>
                    <p class="black--text font-weight-bold">{{ n ? n : "-" }}</p>
                  </div>
                </div>
                <v-toolbar class="pt-1 px-0" dense flat>
                  <span class="caption font-weight-regular"
                    >KRA Provider: <b>{{ btmdata.reskra && btmdata.reskra.kra_status && btmdata.reskra.kra_status.app_kra ? btmdata.reskra.kra_status.app_kra : "-" }} | {{ btmdata ? (btmdata.mode ? "Modify" : "New") : "" }}</b> <br />
                    KRA status: <b>{{ btmdata.reskra && btmdata.reskra.kra_status && btmdata.reskra.kra_status.app_status_message ? btmdata.reskra.kra_status.app_status_message : "-" }}</b> <br />
                    KRA Update Status: <b>{{ btmdata.reskra && btmdata.reskra.kra_status && btmdata.reskra.kra_status.app_update_status_message ? btmdata.reskra.kra_status.app_update_status_message : "-" }}</b></span
                  >
                  <v-spacer></v-spacer>
                  <v-btn @click="setUPloadKra()" class="text-none elevation-0 rounded-lg white--text" :loading="delbtn" color="blue"> Upload KRA </v-btn>
                </v-toolbar>
              </v-stepper-content>

              <v-stepper-content step="3">
                <div class="overflow-y-auto overflow-x-hidden" style="height: 346px !important" v-if="btmdata.reskra && btmdata.reskra.kra_status">
                  <div v-for="(n, l) in btmdata.reskra.kra_status" :key="l">
                    <p class="grey--text mb-0">{{ l ? l : "-" }}</p>
                    <p class="black--text font-weight-bold">{{ n ? n : "-" }}</p>
                  </div>
                </div>
                <v-toolbar class="pt-1" dense flat height="78px" style="height: 68px !important;">
                  <span class="caption font-weight-regular"
                    >KRA Provider: <b>{{ btmdata.reskra && btmdata.reskra.kra_status && btmdata.reskra.kra_status.app_kra ? btmdata.reskra.kra_status.app_kra : "-" }} | {{ btmdata ? (btmdata.mode ? "Modify" : "New") : "" }}</b> <br />
                    KRA status: <b>{{ btmdata.reskra && btmdata.reskra.kra_status && btmdata.reskra.kra_status.app_status_message ? btmdata.reskra.kra_status.app_status_message : "-" }}</b> <br />
                    KRA Update Status: <b>{{ btmdata.reskra && btmdata.reskra.kra_status && btmdata.reskra.kra_status.app_update_status_message ? btmdata.reskra.kra_status.app_update_status_message : "-" }}</b></span
                  >
                  <v-spacer></v-spacer>
                </v-toolbar>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
          <v-btn v-if="krastatdata.kra == '1' && krastatdata.kraDocumentUploaded == '1'" elevation="0" color="primary" class="text-none ml-7 mb-5" @click="dialogkraconf = true" dense >RE-initiate KRA</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogkraconf" persistent max-width="300">
      <v-card class="pa-4">
        <p class="title font-weight-semibold">
          Are you Want to Re-initiate the KRA Process
        </p>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="rounded-lg black" dense class="elevation-0 text-none white--text" @click="dialogkraconf = false">
            No
          </v-btn>
          <v-btn color="primary" dense class="elevation-0 rounded-lg text-none white--text" :loading="krareverload" @click="revertkrastatus()">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="bottomload" class="rounded-0">
      <div class="text-center">
        <v-progress-circular :size="60" :width="4" color="#0037B7" indeterminate></v-progress-circular>
        <p v-if="kraform" class="font-weight-bold fs-18 white--text mt-2">fetching your KRA...</p>
      </div>
    </v-overlay>
    <v-dialog persistent v-model="jvdialog" max-width="440">
      <v-card class="rounded-xl">
        <v-toolbar dense flat>
          <p class="mb-0 font-weight-bold">Mark JV as already passed?</p>
          <v-spacer></v-spacer>
          <v-btn :disabled="jvbtn" icon @click="jvdialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="pa-4">
          <p class="mb-8">
            This marks <b>{{ jvItem.client_id }}</b>'s <b>{{ jvItem.request }}</b> request as having its journal entry already created at back office. The system will <b>NOT</b> pass a new JV when this request is approved. Only do this after confirming in back office that the JV exists.
          </p>
          <v-row no-glutters>
            <v-col cols="6">
              <v-btn @click="jvdialog = false" block :disabled="jvbtn" color="#eeeeee" class="elevation-0 rounded-lg">
                <span class="text-none">Cancel</span>
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn @click="setJvAlreadyPassed()" block :disabled="jvbtn" :loading="jvbtn" color="#FF1717" class="elevation-0 rounded-lg">
                <span class="white--text text-none">Yes, mark it</span>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="cdsldialog" class="overflow-hidden" max-width="800">
      <v-card class="rounded-xl overflow-hidden elevation-0">
        <!-- the page snackbar sits behind this dialog; the modal stays open on failure so errors must show here -->
        <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition" v-model="snackbar" timeout="5000" :value="true" :color="snackbarclr" absolute outlined top right>
          <v-icon class="mr-2" :color="snackbarclr">mdi-alert-outline</v-icon>
          {{ snackmsgbar }}
          <v-icon @click="snackbar = false" class="float-right" :color="snackbarclr">mdi-close-circle</v-icon>
        </v-snackbar>
        <v-toolbar dense flat>
          <p class="mb-0 font-weight-bold">CDSL data confirmation - {{ cdslitem.client_id }} | {{ cdslitem.request }}</p>
          <v-spacer></v-spacer>
          <v-btn :disabled="cdslsubmit" icon @click="cdsldialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <div class="pa-4" style="height: calc(100vh - 166px); overflow-y: scroll">
          <div v-for="(w, e) in cdslpayload" :key="e">
            <div v-if="w && typeof w == 'object' && !Array.isArray(w)">
              <p class="font-weight-bold">{{ e.split("||")[0] }}</p>
              <v-row v-for="(t, y) in w" :key="y" no-glutters>
                <v-col class="pt-0 subtitle-2" cols="4">{{ y }}</v-col>
                <v-col class="pt-0" cols="8">
                  <v-text-field :disabled="!cdsleditmode" color="#fb8c00" dense v-model="cdslpayload[e][y]" class="rounded-lg" label="" single-line hide-details> </v-text-field>
                </v-col>
              </v-row>
              <v-divider class="my-2"></v-divider>
            </div>
          </div>
        </div>
        <v-divider></v-divider>
        <v-toolbar dense flat>
          <v-text-field required v-if="cdsleditmode" :rules="[(v) => !!v || 'Reason is required']" hide-details type="text" v-model="cdslreason" label="modification reason" class="rounded-lg" clearable></v-text-field>
          <v-spacer></v-spacer>
          <v-btn v-if="!cdsleditmode" :disabled="cdslsubmit" @click="cdsleditmode = true" class="elevation-0 rounded-md mr-4 text-none font-weight-bold" text>
            <span><v-icon>mdi-grease-pencil</v-icon> edit</span>
          </v-btn>
          <v-btn :loading="cdslsubmit" :disabled="cdslsubmit || !cdslReasonOk" @click="setCdslFromModal()" color="#3F51B5" class="elevation-0 rounded-md">
            <span class="white--text text-none">Push to CDSL</span>
          </v-btn>
        </v-toolbar>
      </v-card>
    </v-dialog>
    <v-dialog v-model="cdslresdialog" max-width="560">
      <v-card class="rounded-xl">
        <v-toolbar dense flat>
          <p class="mb-0 font-weight-bold">CDSL {{ cdslresult.title }} - {{ cdslresult.client_id }} | {{ cdslresult.request }}</p>
          <v-spacer></v-spacer>
          <v-btn icon @click="cdslresdialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <div class="pa-4 text-left" style="max-height: calc(100vh - 166px); overflow-y: auto">
          <p v-if="cdslresult.msg" class="font-weight-bold">{{ cdslresult.msg }}</p>
          <div v-for="(f, i) in cdslresult.entries" :key="i">
            <p class="font-weight-bold mb-1">File {{ i + 1 }}</p>
            <div v-for="(v, k) in f" :key="k">
              <v-row v-if="v === null || typeof v != 'object'" no-glutters>
                <v-col class="py-0 subtitle-2 grey--text" cols="4">{{ k }}</v-col>
                <v-col class="py-0 subtitle-2" cols="8" style="word-break: break-all">{{ v === null || v === "" ? "-" : v }}</v-col>
              </v-row>
            </div>
            <v-btn v-if="f.file_path" small text color="primary" class="text-none px-0 mt-1" target="_blank" :href="cdslFileUrl(f.file_path)"><v-icon small class="mr-1">mdi-download</v-icon>Download {{ f.file_name || "file" }}</v-btn>
            <v-divider class="my-2"></v-divider>
          </div>
        </div>
      </v-card>
    </v-dialog>
      <v-dialog persistent v-model="retaineddia" max-width="400">
      <v-card class="rounded-xl">
        <v-toolbar dense flat>
          <p class="mb-0 font-weight-bold">Request Retained confirmation</p>
          <v-spacer></v-spacer>
          <v-btn :disabled="completebtn" icon @click="retaineddia = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="pa-4">
          <!-- <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="setReject()">
            <v-text-field required :rules="[v => !!v || 'Reason is required']" v-model="rejectreason"
              label="Reject reason" class="rounded-lg" outlined clearable></v-text-field>

            <v-btn :disabled="!valid" type="submit" :loading="rejbtn" block color="#FF1717" large
              class="elevation-0 rounded-lg mb-4">
              <span class="white--text text-none">Reject this request</span>
            </v-btn>
          </v-form> -->
          <p class="mb-8">
            Are you sure the <b>{{ btmdata.client_id }}</b> confirmation for retaineddia request for <b>{{ btmdata.request }}</b> ?
          </p>
          <v-row no-glutters>
            <v-col cols="6">
              <v-btn @click="comdialog = false" block :disabled="completebtn" color="#eeeeee" class="elevation-0 rounded-lg">
                <span class="text-none">Cancel</span>
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn @click="setCompleteretained()" block :disabled="completebtn" :loading="completebtn" color="orange" class="elevation-0 rounded-lg">
                <span class="white--text text-none">Yes</span>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {apirkyc, apidoc} from "../api.js";
import axios from "axios";
import exportFromJSON from "export-from-json";
import * as XLSX from "xlsx";
import LayOut from "../components/LayOut.vue";

export default {
  components: {
    LayOut,
  },

  data: () => ({
    snackbar: false,
    snackbarclr: "default",
    snackmsgbar: "",
    dashboarddata: [],
    showdata: [],
    search: null,
    tab: 0,
    btmltab: 0,
    btmrtab: 0,
    mainloader: true,
    btmsheet: false,
    btmdata: [],
    rejectreason: "",
    rejdialog: false,
    valid: true,
    ipaddress: null,
    geolocation: null,
    comcount: 0,
    rejcount: 0,
    viewcount: 0,
    esigncount: 0,
    esignpcount: 0,

    uemail: null,
    uuid: null,
    uname: null,
    completebtn: false,
    rejbtn: false,
    comdialog: false,
    status: null,
    request: null,
    requestFilter: "",
    page: 1,
    pageSize: 100,
    totalItems: 0,
    totalPageCount: 0,
    alldate: null,
    menu2: false,
    menu22: false,
    menu2to: false,
    bottomload: false,
    kraform: null,
    dateSelectto: "",
    dateSelect2: "",
    maxDate2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),

    headers: [
      // { text: 'sr.No', value: 'sno' },
      {text: "Initiated Date", value: "date_time"},
      {text: "Action", value: "view", sortable: false},
      {text: "Mobile", value: "mobile_no", sortable: false},
      {text: "Client Id", value: "client_id", sortable: false},
      {text: "Name", value: "client_name", sortable: false},
      {text: "Branch Id", value: "branch_id", sortable: false},

      {text: "DP code", value: "dp_code"},
      {text: "Email", value: "client_email", align: " d-none", sortable: false},
      {text: "PanNumber", value: "client_pan", sortable: false},
      {text: "Request", value: "request"},
      {text: "e-signed date", value: "e_signed_datetime"},
      {text: "Status", value: "app_status"},
      // { text: '', value: 'moreInfo' },
    ],
    headersc: [
      // { text: 'sr.No', value: 'sno' },
      {text: "Completed Date", value: "approval_date_time"},
      {text: "Action", value: "view", sortable: false},
      {text: "Mobile", value: "mobile_no", sortable: false},
      {text: "Client Id", value: "client_id", sortable: false},
      {text: "Name", value: "client_name", sortable: false},
      {text: "DP code", value: "dp_code"},
      {text: "Email", value: "client_email", align: " d-none", sortable: false},
      {text: "PanNumber", value: "client_pan", sortable: false},
      {text: "Request", value: "request"},
      {text: "Status", value: "app_status"},
      {text: "KRA", value: "KRA_view", sortable: false},
      {text: "Initiated date", value: "date_time"},
      {text: "e-signed date", value: "e_signed_datetime"},
      // { text: '', value: 'moreInfo' },
    ],
    headersr: [
      // { text: 'sr.No', value: 'sno' },
      {text: "Rejected Date", value: "rejection_date_time"},
      {text: "Action", value: "view", sortable: false},
      {text: "Mobile", value: "mobile_no", sortable: false},
      {text: "Client Id", value: "client_id", sortable: false},
      {text: "Name", value: "client_name", sortable: false},
      {text: "DP code", value: "dp_code"},
      {text: "Email", value: "client_email", align: " d-none", sortable: false},
      {text: "PanNumber", value: "client_pan", sortable: false},
      {text: "Request", value: "request"},
      {text: "Status", value: "app_status"},
      {text: "Initiated date", value: "date_time"},
      {text: "e-signed date", value: "e_signed_datetime"},
      // { text: '', value: 'moreInfo' },
    ],
    closbtnload:false,
    retaineddia:false,
    kradialog: false,
    el: 1,
    delbtn: false,
    cor_addr: {},
    per_details: {},
    per_addr: {},
    krastatdata:[],
    karstatupmob:"",
    dialogkraconf:false,
    krareverload:false,
    uploadresdata:[],
    bakchekload:false,
    jvdialog: false,
    jvbtn: false,
    jvItem: {},
    cdslmanual: false,
    cdslbusy: {}, // row key -> "push" | "res" while that row's request is in flight
    cdslfiles: {}, // row key -> zip path generated this session; survives sheet reopen / list reload even if the row's cdsl_file_path is not saved yet
    cdsldialog: false,
    cdslitem: {},
    cdslpayload: {},
    cdsleditmode: false,
    cdslreason: "",
    cdslsubmit: false, // true while the modal's push is in flight
    cdslresdialog: false,
    cdslresult: {},
    cdslskipdialog: false,
    cdslskipitem: {},
    cdslskipreason: "",
  }),
  created() {
    document.title = "Rekyc-dashboard";
  },
  mounted() {
    let list = atob(localStorage.getItem("stapilist"));
    this.uemail = localStorage.getItem("email");
    this.uuid = localStorage.getItem("empcode");
    this.uname = localStorage.getItem("name");

    this.dateSelect2 = new Date(new Date().getFullYear(), new Date().getMonth() - 2, new Date().getDate()).toISOString().slice(0, 10);
    this.dateSelectto = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1).toISOString().slice(0, 10);
    if (this.uemail && this.uuid && this.uname && (this.uemail.split("@")[1] == "zebuetrade.com" || (list && this.getemailInList(this.uemail, "emailId", list)))) {
      this.dayCustom();
      this.getPublicIP();
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition);
      } else {
        this.geolocation = "Not able to get location";
        console.log(this.geolocation);
      }
    } else {
      // this.$router.push("/");
    }
  },
  methods: {
    checdatafun(a){
      this.bakchekload = true
console.log("aa",a)
const axios = require('axios');
let data = JSON.stringify({
  "client_id": a.client_id,
  "bank_account_no": a.BankAccountNumber,
  "bank_name": a.BankName,
  "app_status": a.app_status
});

let config = {
  method: 'post',
  maxBodyLength: Infinity,
  url: `${apirkyc}manual_bank_update`,
  headers: { 
    'Content-Type': 'application/json'
  },
  data : data
};
var axiosThis = this
axios.request(config)
.then((response) => {
  console.log(JSON.stringify(response.data));
  axiosThis.bakchekload = false
  console.log("start",response.data.data)
  if(response.data.data == 'Successfully updated'){
  console.log("iff in",response.data.data)

    axiosThis.snackbar = true;
            axiosThis.snackbarclr = "green";
            axiosThis.snackmsgbar = response.data.data 
}else{
  axiosThis.snackbar = true;
            axiosThis.snackbarclr = "red";
            axiosThis.snackmsgbar = response.data 
}


})
.catch((error) => {
  console.log(error);
        axiosThis.bakchekload = false
 axiosThis.snackbar = true;
            axiosThis.snackbarclr = "red";
            axiosThis.snackmsgbar = error
});

    },
    clossendmailapi(){
      this.closbtnload = true
      const axios = require('axios');
      let data = JSON.stringify({
        "client_id": this.btmdata.client_id,
        "type":this.btmdata.request
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apirkyc}/branch_mail_manual_send`,
        headers: { 
          'Content-Type': 'application/json'
        },
        data : data
      };
var axiosThis = this
      axios.request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
      axiosThis.closbtnload = false
if(response.data.stat == 'Ok'){
    axiosThis.snackbar = true;
            axiosThis.snackbarclr = "green";
            axiosThis.snackmsgbar = response.data.msg 
}else{
  axiosThis.snackbar = true;
            axiosThis.snackbarclr = "red";
            axiosThis.snackmsgbar = response.data 
}
      })
      .catch((error) => {
        console.log(error);
      axiosThis.closbtnload = false
 axiosThis.snackbar = true;
            axiosThis.snackbarclr = "red";
            axiosThis.snackmsgbar = error
      });

    },
    // "JV Already Passed" is only for e-signed requests whose JV call may have timed out (no vno recorded yet)
    canMarkJvPassed(item) {
      const jvTypes = ["DDPI", "mobile", "email", "address", "bank"];
      return jvTypes.includes(item.request_type || item.request) && item.app_status === "e-signed completed" && String(item.flag_values) === "0" && !item.vno;
    },
    openJvDialog(item) {
      if (this.jvbtn) return;
      this.jvItem = item;
      this.jvdialog = true;
    },
    setJvAlreadyPassed() {
      if (this.jvbtn) return;
      this.jvbtn = true;
      let config = {
        method: "post",
        url: `${apirkyc}jv_already_passed`,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          client_id: this.jvItem.client_id,
          request_type: this.jvItem.request_type || this.jvItem.request,
        }),
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          // "vno already present" comes back as HTTP 200 with stat Not_ok, so only stat decides success
          axiosThis.snackbar = true;
          if (response.data && response.data.stat === "Ok") {
            axiosThis.snackbarclr = "green";
            axiosThis.snackmsgbar = response.data.msg;
            // jvItem is the open detail record, so this swaps the button for the vno in the sheet header
            axiosThis.$set(axiosThis.jvItem, "vno", response.data.vno || "JV ALREADY PASSED");
            axiosThis.getDashboard();
          } else {
            axiosThis.snackbarclr = "#FF1717";
            axiosThis.snackmsgbar = response.data && response.data.msg ? response.data.msg : "Unable to mark JV as already passed";
          }
        })
        .catch((error) => {
          console.log(error);
          // 400/404/500 responses still carry a msg; fall back to a generic message on network failure/timeout
          const res = error.response && error.response.data;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = res && res.msg ? res.msg : "Network error, please try again";
        })
        .finally(() => {
          axiosThis.jvbtn = false;
          axiosThis.jvdialog = false;
        });
    },
    // ---- CDSL BO-Modify push ----
    isCdslType(item) {
      if (item.request == "segment") return this.segmentForCdsl(item);
      return ["mobile", "email", "address", "bank", "income", "DDPI", "nominee"].includes(item.request);
    },
    // a segment request goes to CDSL only when equity_status = NO
    segmentForCdsl(item) {
      return String(item.equity_status || "").trim().toUpperCase() == "NO";
    },
    cdslStatus(item) {
      return String(item.cdsl_status || "").toUpperCase();
    },
    // Push while nothing has reached CDSL (UPLD_FAILED never got there). RESP_FAILED did reach CDSL, so it is only
    // re-pushed through the Manual confirmation modal: Push stays disabled for it until the toggle is on Manual
    canCdslPush(item) {
      if (String(item.cdsl_complete) == "1" || this.cdslBlockReason(item)) return false;
      if (this.cdslManualOnly(item)) return this.cdslmanual;
      return ["", "SKIPPED", "MANUAL", "EDITED", "UPLD_FAILED", "REJECTED"].includes(this.cdslStatus(item));
    },
    cdslManualOnly(item) {
      return this.cdslStatus(item) == "RESP_FAILED";
    },
    isCdslManual() {
      return this.cdslmanual;
    },
    setCdslMode(mode) {
      if (mode) this.cdslmanual = mode == "manual";
    },
    // EDITED rows carry the operator's reason for hand-modifying the file; cdsl_response may arrive as a JSON string
    cdslEditReason(item) {
      const label = {EDITED: "Edit reason", SKIPPED: "Skip reason"}[this.cdslStatus(item)];
      if (!label) return "";
      let res = item.cdsl_response;
      if (typeof res === "string") {
        try {
          res = JSON.parse(res);
        } catch (e) {
          res = null;
        }
      }
      return res && res.reason ? `${label}: ${res.reason}` : "";
    },
    // "Skip CDSL" only marks the row (no upload, no file); offered while nothing has reached CDSL
    canCdslSkip(item) {
      return String(item.cdsl_complete) != "1" && ["", "SKIPPED", "MANUAL", "EDITED", "UPLD_FAILED", "REJECTED"].includes(this.cdslStatus(item));
    },
    openCdslSkip(item) {
      if (this.isCdslBusy(item)) return;
      this.cdslskipitem = item;
      this.cdslskipreason = "";
      this.cdslskipdialog = true;
    },
    setCdslSkip() {
      const item = this.cdslskipitem;
      if (this.isCdslBusy(item)) return;
      this.setCdslBusy(item, "skip");
      const reason = (this.cdslskipreason || "").trim();
      let config = {
        method: "post",
        url: `${this.cdslBase()}/cdsl_skip`,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({client_id: item.client_id, request_type: item.request, reason}),
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          const data = response.data || {};
          const ok = String(data.cdsl_status || "").toUpperCase() == "SKIPPED";
          axiosThis.showCdslSnack(ok ? "#43A833" : "#FF1717", axiosThis.cdslMsg(data));
          if (ok) axiosThis.cdslskipdialog = false;
          // "already pushed" also carries the row's real status, so reload either way
          axiosThis.refreshCdslRow(item, ok ? {cdsl_status: "SKIPPED", cdsl_response: {reason}} : data.cdsl_status ? {cdsl_status: data.cdsl_status} : null);
        })
        .catch((error) => {
          console.log(error);
          axiosThis.showCdslSnack("#FF1717", axiosThis.cdslErrMsg(error));
        })
        .finally(() => {
          axiosThis.setCdslBusy(item, null);
        });
    },
    cdslStatusText(item) {
      const st = this.cdslStatus(item);
      if (!st) return this.cdslBlockReason(item) ? "Not applicable" : "Not pushed";
      const texts = {SKIPPED: "Skipped", MANUAL: "File generated", EDITED: "File edited", UPLD_FAILED: "Upload failed", PROCESSING: "Processing", UPLOADED: "CDSL initiated", PENDING: "CDSL initiated", RESP_FAILED: "Response failed", REJECTED: "CDSL Rejected", ACCEPTED: "CDSL Completed"};
      return texts[st] || item.cdsl_status;
    },
    // requests the CDSL BO-Modify flow cannot handle; "" when pushable. set_defalut is the backend's spelling
    cdslBlockReason(item) {
      if (item.request != "bank") return "";
      if (String(item.option || "").toLowerCase() == "delete") return "removal not supported";
      if (String(item.set_defalut || "").toLowerCase() != "yes") return "not the primary account";
      return "";
    },
    // plain-language versions of the bank request's raw option / set_defalut values
    bankOptionText(item) {
      const texts = {add: "Add a bank account", modify: "Update bank account details", delete: "Remove a bank account"};
      return texts[String(item.option || "").toLowerCase()] || item.option || "-";
    },
    bankDefaultText(item) {
      const value = String(item.set_defalut || "").toLowerCase();
      if (!value) return "-";
      return value == "yes" ? "Yes" : "No";
    },
    // Response only once something has reached CDSL and is not finished
    canCdslResponse(item) {
      return ["UPLOADED", "PENDING", "RESP_FAILED"].includes(this.cdslStatus(item));
    },
    // the BO-Modify push targets requests the client has e-signed but the admin has not yet approved
    // a nominee opt-out (nominee_req = no AND nominee_optout = Y, empty or missing) never goes to CDSL, so it gets no
    // CDSL controls at all
    cdslEligible(item) {
      return this.isCdslType(item) && item.app_status == "e-signed completed" && !this.nomineeOptedOut(item);
    },
    nomineeOptedOut(item) {
      if (item.request != "nominee") return false;
      const optout = String(item.nominee_optout || "").trim().toUpperCase();
      return String(item.nominee_req || "").trim().toLowerCase() == "no" && (optout == "Y" || optout == "");
    },
    // a request that goes through CDSL can only be approved once CDSL has accepted it; requests CDSL cannot take
    // (blocked bank requests, other types, e-signed pending) keep Complete as before. A manually generated file
    // (MANUAL) or a failed status check (RESP_FAILED) can also be completed by the operator; a hand-edited file
    // (EDITED) cannot, it has to go through CDSL first
    cdslBlocksComplete(item) {
      // a hand-edited file must go through CDSL first; this wins over every exemption below (guardian, blocked, ...)
      if (this.cdslStatus(item) == "EDITED") return true;
      if (this.nomineeHasGuardian(item)) return false;
      return this.cdslEligible(item) && !this.cdslBlockReason(item) && !["ACCEPTED", "MANUAL", "RESP_FAILED", "SKIPPED"].includes(this.cdslStatus(item));
    },
    // a nominee request with a guardian (minor nominee) on any of the three nominees can always be completed
    nomineeHasGuardian(item) {
      if (item.request != "nominee") return false;
      return ["guardian_name", "guardian_name2", "guardian_name3"].some((k) => {
        const v = String(item[k] || "").trim().toLowerCase();
        return v && v != "null" && v != "-";
      });
    },
    cdslChipColor(item) {
      const st = this.cdslStatus(item);
      if (st == "ACCEPTED" || String(item.cdsl_complete) == "1") return "#43A833";
      if (st == "UPLD_FAILED" || st == "RESP_FAILED") return "#FF1717";
      if (st == "REJECTED") return "#FF1717";
      if (st == "UPLOADED" || st == "PENDING") return "#1E88E5";
      if (st == "EDITED") return "blue-grey";
      if (st == "SKIPPED") return "#F9A825";
      return "grey";
    },
    // rows are copies (itemsWithSno), so busy state is keyed by client + request rather than stored on the row
    cdslKey(item) {
      return `${item.client_id}|${item.request}`;
    },
    isCdslBusy(item, action) {
      const busy = this.cdslbusy[this.cdslKey(item)];
      return action ? busy === action : !!busy;
    },
    setCdslBusy(item, action) {
      if (action) this.$set(this.cdslbusy, this.cdslKey(item), action);
      else this.$delete(this.cdslbusy, this.cdslKey(item));
    },
    // apirkyc is set with or without a trailing slash depending on the environment
    cdslBase() {
      return `${apirkyc.replace(/\/+$/, "")}/cdsl`;
    },
    cdslPushUrl(item) {
      return `${this.cdslBase()}/cdsl_modify_push/${item.request}/${item.client_id}`;
    },
    cdslFileUrl(path) {
      return `${apidoc}?path=${encodeURIComponent(path)}`;
    },
    cdslMsg(data) {
      if (data && data.msg) return typeof data.msg === "string" ? data.msg : JSON.stringify(data.msg);
      return typeof data === "string" && data ? data : JSON.stringify(data);
    },
    cdslErrMsg(error) {
      // 400/404/500 bodies carry a human-readable msg (business outcomes, not crashes); fall back only on network failure
      const res = error.response && error.response.data;
      return res && res.msg ? this.cdslMsg(res) : error.message || "Network error, please try again";
    },
    showCdslSnack(color, msg) {
      this.snackbar = true;
      this.snackbarclr = color;
      this.snackmsgbar = msg;
    },
    // DDPI returns one file/ack per SEBI purpose; the exact shape is not final, so pick out every object
    // that looks like a file/ack/status entry instead of relying on fixed key names
    collectCdslEntries(node, out = []) {
      if (Array.isArray(node)) {
        node.forEach((n) => this.collectCdslEntries(n, out));
        return out;
      }
      if (!node || typeof node !== "object") return out;
      const lists = Object.values(node).filter((v) => Array.isArray(v) && v.some((x) => x && typeof x === "object"));
      if (lists.length) lists.forEach((l) => this.collectCdslEntries(l, out));
      else if (["file_path", "file_name", "ack", "AcknowledgmentID", "update_status"].some((k) => k in node)) out.push(node);
      else Object.values(node).forEach((v) => this.collectCdslEntries(v, out));
      return out;
    },
    showCdslResult(title, item, msg, entries) {
      this.cdslresult = {title, client_id: item.client_id, request: item.request, msg, entries};
      this.cdslresdialog = true;
    },
    // NomineeDetails: [{..},{..}] -> NomineeDetails||0, NomineeDetails||1 so every block renders as its own section
    flattenCdslPayload(data) {
      const flat = {};
      for (const [key, value] of Object.entries(data)) {
        if (Array.isArray(value) && value.length) value.forEach((v, i) => (flat[`${key}||${i}`] = {...v}));
        else flat[key] = value && typeof value === "object" && !Array.isArray(value) ? {...value} : value;
      }
      return flat;
    },
    foldCdslPayload(flat) {
      const out = {};
      for (const [key, value] of Object.entries(flat)) {
        const [group, idx] = key.split("||");
        if (idx === undefined) out[key] = value;
        else {
          if (!Array.isArray(out[group])) out[group] = [];
          out[group][Number(idx)] = value;
        }
      }
      return out;
    },
    getCdslPreview(item) {
      if (this.isCdslBusy(item)) return;
      this.setCdslBusy(item, "push");
      let config = {
        method: "post",
        url: `${this.cdslPushUrl(item)}?json=true`,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({}),
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          const data = response.data;
          // the grouped payload never has a msg key; {"msg": ...} is always a refusal
          if (data && typeof data === "object" && !Array.isArray(data) && !("msg" in data) && Object.keys(data).length) {
            axiosThis.cdslitem = item;
            axiosThis.cdslpayload = axiosThis.flattenCdslPayload(data);
            axiosThis.cdsleditmode = false;
            axiosThis.cdslreason = "";
            axiosThis.cdsldialog = true;
          } else {
            axiosThis.showCdslSnack("#FF1717", axiosThis.cdslMsg(data));
          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.showCdslSnack("#FF1717", axiosThis.cdslErrMsg(error));
        })
        .finally(() => {
          axiosThis.setCdslBusy(item, null);
        });
    },
    setCdslPush(item) {
      if (this.isCdslBusy(item) || this.cdslManualOnly(item)) return;
      this.setCdslBusy(item, "push");
      this.requestCdslPush(item, {}).finally(() => this.setCdslBusy(item, null));
    },
    // reloads the list and copies the row's new cdsl_status onto the open Verify sheet (btmdata is a copy the
    // reload does not touch); fallback is used only when the row is not in the reloaded page
    refreshCdslRow(item, fallback) {
      const key = this.cdslKey(item);
      return this.getDashboard().then(() => {
        const fresh = this.dashboarddata.find((r) => this.cdslKey(r) === key);
        const patch = fresh ? {cdsl_status: fresh.cdsl_status, cdsl_complete: fresh.cdsl_complete, cdsl_response: fresh.cdsl_response, ...(fresh.cdsl_file_path ? {cdsl_file_path: fresh.cdsl_file_path} : {})} : fallback;
        if (patch && this.btmsheet && this.cdslKey(this.btmdata) === key) Object.entries(patch).forEach(([k, v]) => this.$set(this.btmdata, k, v));
      });
    },
    // "Download CDSL": reuse cdsl_file_path when present; generating (manual=true) consumes a new CDSL serial number
    // every call, so it only runs when no file exists yet
    getCdslZip(item) {
      if (this.isCdslBusy(item)) return;
      this.setCdslBusy(item, "download");
      const existing = this.cdslFilePath(item);
      const fileReq = existing ? Promise.resolve({file_path: existing}) : this.generateCdslZip(item);
      fileReq.then((file) => file && this.downloadCdslZip(file.file_path, file.file_name)).finally(() => this.setCdslBusy(item, null));
    },
    // "Regenerate": always calls manual=true, even when a file exists, and downloads the new one
    regenerateCdslZip(item) {
      if (this.isCdslBusy(item)) return;
      this.setCdslBusy(item, "regen");
      this.generateCdslZip(item)
        .then((file) => file && this.downloadCdslZip(file.file_path, file.file_name))
        .finally(() => this.setCdslBusy(item, null));
    },
    cdslFilePath(item) {
      return item.cdsl_file_path || this.cdslfiles[this.cdslKey(item)] || "";
    },
    // remember the zip so "Download CDSL" reuses it instead of regenerating (which burns a serial number)
    rememberCdslFile(item, path) {
      this.$set(this.cdslfiles, this.cdslKey(item), path);
      this.$set(item, "cdsl_file_path", path);
    },
    // backend paths can be Windows () or POSIX (/); only the last segment is a usable download name
    cdslBaseName(path) {
      return String(path || "").split(/[\\/]/).pop();
    },
    generateCdslZip(item) {
      let config = {
        method: "post",
        url: `${this.cdslPushUrl(item)}?manual=true`,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({}),
      };

      let axiosThis = this;
      return axios
        .request(config)
        .then((response) => {
          const data = response.data || {};
          if (data.msg == "file gen success" && data.file_path) {
            axiosThis.rememberCdslFile(item, data.file_path);
            axiosThis.refreshCdslRow(item, {cdsl_status: "MANUAL", cdsl_file_path: data.file_path});
            return data;
          }
          axiosThis.showCdslSnack("#FF1717", axiosThis.cdslMsg(data));
          return null;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.showCdslSnack("#FF1717", axiosThis.cdslErrMsg(error));
          return null;
        });
    },
    // fetched as a blob (like downloadApprovedReport) so an error body shows as a snackbar instead of a broken tab,
    // and the save is not caught by the popup blocker after the async generate step
    downloadCdslZip(path, name) {
      let axiosThis = this;
      const showBlobError = (blob) =>
        blob.text().then((txt) => {
          let parsed = {};
          try {
            parsed = JSON.parse(txt);
          } catch (e) {
            parsed = {};
          }
          axiosThis.showCdslSnack("#FF1717", parsed.msg ? axiosThis.cdslMsg(parsed) : txt || "Unable to download the CDSL file");
        });
      return axios({method: "get", url: this.cdslFileUrl(path), responseType: "blob"})
        .then((response) => {
          const blob = response.data;
          if (blob && blob.type && blob.type.indexOf("application/json") !== -1) return showBlobError(blob);
          // Content-Disposition is only readable if the backend exposes it via CORS; fall back to the generated name
          const cd = (response.headers && response.headers["content-disposition"]) || "";
          const match = cd.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = axiosThis.cdslBaseName(match ? decodeURIComponent(match[1]) : name || path) || "cdsl.zip";
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.log(error);
          const data = error.response && error.response.data;
          if (data instanceof Blob) return showBlobError(data);
          axiosThis.showCdslSnack("#FF1717", axiosThis.cdslErrMsg(error));
        });
    },
    setCdslFromModal() {
      if (this.cdslsubmit || !this.cdslReasonOk) return;
      // unedited data goes as {} so the backend rebuilds it; once edit is clicked the payload + reason are sent
      const body = this.cdsleditmode ? {payload: this.foldCdslPayload(this.cdslpayload), reason: this.cdslreason.trim()} : {};
      this.cdslsubmit = true;
      this.requestCdslPush(this.cdslitem, body)
        .then((ok) => {
          if (ok) this.cdsldialog = false;
        })
        .finally(() => (this.cdslsubmit = false));
    },
    // resolves true on success
    requestCdslPush(item, body) {
      let config = {
        method: "post",
        url: this.cdslPushUrl(item),
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(body),
      };

      let axiosThis = this;
      return axios
        .request(config)
        .then((response) => {
          const data = response.data || {};
          const ok = data.success == "True" || data.success === true || data.msg == "Upload Success";
          const entries = ok ? axiosThis.collectCdslEntries(data) : [];
          if (ok && data.file_path) axiosThis.rememberCdslFile(item, data.file_path);
          // DDPI produces one file/ack per SEBI purpose; show them all
          if (entries.length > 1) axiosThis.showCdslResult("push", item, axiosThis.cdslMsg(data), entries);
          if (ok) axiosThis.showCdslSnack("#43A833", `${axiosThis.cdslMsg(data)}${data.ack ? ` (Ack: ${data.ack})` : ""}`);
          else axiosThis.showCdslSnack("#FF1717", axiosThis.cdslMsg(data));
          // cdsl_status moves on success and failure alike (UPLOADED / UPLD_FAILED), so always reload the row
          axiosThis.refreshCdslRow(item, ok ? {cdsl_status: "UPLOADED"} : data.cdsl_status ? {cdsl_status: data.cdsl_status} : null);
          return ok;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.showCdslSnack("#FF1717", axiosThis.cdslErrMsg(error));
          // a 400 refusal / 500 failure / "already pushed" can still have moved cdsl_status, so reload when the server answered
          const res = error.response && error.response.data;
          if (error.response) axiosThis.refreshCdslRow(item, res && res.cdsl_status ? {cdsl_status: res.cdsl_status} : null);
          return false;
        });
    },
    setCdslStatusCheck(item) {
      if (this.isCdslBusy(item)) return;
      this.setCdslBusy(item, "res");
      let config = {
        method: "post",
        url: `${this.cdslBase()}/cdsl_status_check`,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({client_id: item.client_id, request_type: item.request}),
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          const m = response.data ? response.data.msg : null;
          const entries = axiosThis.collectCdslEntries(m);
          if (entries.length > 1) axiosThis.showCdslResult("status", item, "", entries);
          let fallback = null;
          if (m && typeof m === "object" && !Array.isArray(m)) {
            const st = m.update_status || "Pending";
            const color = !m.success ? "warning" : st == "Accepted" ? "#43A833" : st == "Rejected" ? "#FF1717" : "#2a2a2a";
            // a rejection shows CDSL's own code and reason ("Rejected : <ErrCD> - <ErrDesc>") so the operator knows what
            // to fix; CDSL cuts ErrDesc at 37 characters, so it is shown as-is, never parsed
            let resp = m.response;
            if (typeof resp === "string") {
              try {
                resp = JSON.parse(resp);
              } catch (e) {
                resp = null;
              }
            }
            const errText = st == "Rejected" && resp && typeof resp === "object" ? [resp.ErrCD, resp.ErrDesc].filter(Boolean).join(" - ") : "";
            axiosThis.showCdslSnack(color, errText ? `${st} : ${errText}` : `CDSL ${st}${m.AcknowledgmentID ? ` (Ack: ${m.AcknowledgmentID})` : ""}`);
            fallback = !m.success ? {cdsl_status: "PENDING"} : st == "Accepted" ? {cdsl_status: "ACCEPTED", cdsl_complete: "1"} : st == "Rejected" ? {cdsl_status: "REJECTED"} : null;
          } else if (entries.length > 1) {
            axiosThis.showCdslSnack("#2a2a2a", "CDSL status fetched");
          } else {
            // a plain {"msg": "..."} here means CDSL is still processing, not a failure
            axiosThis.showCdslSnack("warning", axiosThis.cdslMsg(response.data));
          }
          axiosThis.refreshCdslRow(item, fallback);
        })
        .catch((error) => {
          console.log(error);
          axiosThis.showCdslSnack("#FF1717", axiosThis.cdslErrMsg(error));
        })
        .finally(() => {
          axiosThis.setCdslBusy(item, null);
        });
    },
    getemailInList(email, value, list) {
      const rawData = JSON.parse(list);
      return rawData.some((item) => item[value].toUpperCase() === email.toUpperCase());
    },
    formatDateTime(dt) {
      // API sends raw ISO strings like 2026-07-24T10:20:28.123 -> render as YYYY-MM-DD HH:mm:ss
      if (!dt) return "";
      const d = new Date(dt);
      if (isNaN(d.getTime())) return dt; // already-formatted / unexpected value: leave as-is
      const p = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
    },
    onSearch() {
      // same as EKYC searchapicall: api only for 3+ chars, reload when emptied, 1-2 chars are filtered by the table
      const len = (this.search || "").trim().length;
      if (len > 0 && len < 3) return;
      this.page = 1;
      this.getDashboard();
    },
    getDashboard() {
      this.showdata = [];
      this.dashboarddata = [];
      this.mainloader = true;

      // tab (view/com/rej) now lives in the body; ?filter= carries the request-type
      let body = {
        tab: this.tab == 0 ? "view" : this.tab == 1 ? "com" : "rej",
      };
      // all tabs use the selected status_filter from the dropdown; rej defaults to "rejected" when nothing is picked
      if (this.status) body.status_filter = this.status;
      else if (this.tab == 2) body.status_filter = "rejected";
      if (this.dateSelect2 && this.dateSelectto) {
        body.from = this.dateSelect2;
        body.to = this.dateSelectto;
      }
      const term = (this.search || "").trim();
      if (term.length > 2) body.search_term = term; // search is now server-side (ILIKE across all fields)
      let data = JSON.stringify(body);

      let config = {
        method: "post",
        url: `${apirkyc}/dashboard?filter=${this.requestFilter || ""}&limit=${this.pageSize}&offset=${this.page}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      let axiosThis = this;
      // returned so CDSL actions can wait for the reload before refreshing the open Verify sheet
      return axios
        .request(config)
        .then((response) => {
          // console.log(response.data);
          if (response.data.data) {
            let data = response.data.data;
            for (let z = 0; z < data.length; z++) {
              // new contract labels the source table as request_type; keep `request` working for existing UI logic
              data[z].request = data[z].request_type || data[z].request;
              data[z].date_time = axiosThis.formatDateTime(data[z].date_time);
              data[z].approval_date_time = axiosThis.formatDateTime(data[z].approval_date_time);
              data[z].rejection_date_time = axiosThis.formatDateTime(data[z].rejection_date_time);
              data[z].e_signed_datetime = axiosThis.formatDateTime(data[z].e_signed_datetime);
              data[z].e_signed_pdf_path = data[z].e_signed_pdf_path ? `${apidoc}?path=${data[z].e_signed_pdf_path}` : "";
              data[z].e_signed_pdf_path_1 = data[z].e_signed_pdf_path_1 ? `${apidoc}?path=${data[z].e_signed_pdf_path_1}` : "";
              data[z].e_signed_pdf_path_2 = data[z].e_signed_pdf_path_2 ? `${apidoc}?path=${data[z].e_signed_pdf_path_2}` : "";
              data[z].kra_file_path = data[z].kra_file_path ? `${apidoc}?path=${data[z].kra_file_path}` : "";

              data[z].proff_path = data[z].proff_path ? `${apidoc}?path=${data[z].proff_path}` : null;
              data[z].exists_bank_account = data[z].exists_bank_account ? (typeof data[z].exists_bank_account === "string" ? JSON.parse(data[z].exists_bank_account) : data[z].exists_bank_account)[0] : "";
              data[z].activestatus = data[z].activestatus ? (typeof data[z].activestatus === "string" ? JSON.parse(data[z].activestatus) : data[z].activestatus) : "";

              data[z].new_segments = data[z].new_segments ? (typeof data[z].new_segments === "string" ? JSON.parse(data[z].new_segments) : data[z].new_segments) : "";
              data[z].ext_segements = data[z].ext_segements ? (typeof data[z].ext_segements === "string" ? JSON.parse(data[z].ext_segements) : data[z].ext_segements) : "";
              data[z]["aadharxmlfile"] = data[z].proff_path && data[z].request == "address" ? data[z].proff_path.replace(".pdf", ".xml") : "";
            }
            axiosThis.dashboarddata = data;
            axiosThis.showdata = data;

            axiosThis.totalItems = response.data.total || 0;
            axiosThis.totalPageCount = response.data.total_page_count || 0;
            axiosThis.viewcount = response.data.view_count;
            axiosThis.rejcount = response.data.rej_count;
            axiosThis.comcount = response.data.com_count;
            axiosThis.esigncount = response.data.e_signed_completed;
            axiosThis.esignpcount = response.data.e_signed_pending;
          } else {
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "#2a2a2a";
            axiosThis.snackmsgbar = response.data.msg ? response.data.msg : response.data;
            axiosThis.viewcount = 0;
            axiosThis.rejcount = 0;
            axiosThis.comcount = 0;
            axiosThis.esigncount = 0;
            axiosThis.esignpcount = 0;
            axiosThis.totalItems = 0;
            axiosThis.totalPageCount = 0;
          }

          axiosThis.mainloader = false;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.mainloader = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
        });
    },
    getSingledata(item) {
      this.btmrtab = 0;
      item.request == "nominee"
        ? (this.btmltab = 1)
        : item.request == "email"
        ? (this.btmltab = 2)
        : item.request == "mobile"
        ? (this.btmltab = 3)
        : item.request == "address"
        ? ((this.btmltab = 4), (this.btmrtab = 1))
        : item.request == "bank"
        ? ((this.btmltab = 5), (this.btmrtab = 2))
        : item.request == "income"
        ? ((this.btmltab = 6), (this.btmrtab = 3))
        : item.request == "segment"
        ? ((this.btmltab = 7), (this.btmrtab = 4))
        : item.request == "closure"
        ? ((this.btmltab = 8), (this.btmrtab = 5))
        : (this.btmltab = 0);
      this.btmdata = item;
      // every request opens on Auto; Manual is a per-request choice
      this.cdslmanual = false;
      this.btmsheet = true;
    },
    statusChange() {
      // "retained" only applies to closure requests — lock the request filter to closure
      if (this.status === "retained") this.requestFilter = "closure";
      // status_filter is applied server-side; reset to first page and refetch
      this.page = 1;
      this.getDashboard();
    },
    requestChange() {
      // request-type filter (?filter=) is applied server-side; reset to first page and refetch
      this.page = 1;
      this.getDashboard();
    },
    setTypedata() {
      this.alldate = "";
      this.dateSelect2 = new Date(new Date().getFullYear(), new Date().getMonth() - 2, new Date().getDate()).toISOString().slice(0, 10);
      this.dateSelectto = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1).toISOString().slice(0, 10);
      this.search = null;
      this.status = null; // reset status_filter when the tab changes
      this.requestFilter = ""; // request-type filter shouldn't carry over between tabs
      this.page = 1;
      this.dayCustom();
    },
    setComplete() {
      this.completebtn = true;
      var today = new Date();
      var date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      var dateTime = date + " " + time;
      let data = JSON.stringify({
        status: "approved",
        client_id: this.btmdata.client_id,
        rejected_reason: "",
        approved_type: this.btmdata.request,
        branch_mail: this.btmdata.request != "closure" ?  this.btmdata.branch_email : this.btmdata.branch_email_id,
        branch_id:this.btmdata.branch_id  ? this.btmdata.branch_id  : "",
        app_status:this.btmdata.app_status,
        log: {datetime: dateTime, IP_address: this.ipaddress, browser: navigator.appCodeName, Location: this.geolocation, emp_emailid: this.uemail, emp_ID: this.uuid},
      });

      let config = {
        method: "post",
        url: `${apirkyc}/status_update`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          if (response.data) {
            axiosThis.comdialog = false;
            axiosThis.btmsheet = false;
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "#2a2a2a";
            axiosThis.snackmsgbar = response.data.msg ? response.data.msg : response.data;
            axiosThis.btmdata = [];
            // axiosThis.tab = 1;
            axiosThis.getDashboard();
            axiosThis.completebtn = false;
          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
        });
    },

     setCompleteretained() {
      this.completebtn = true;
      var today = new Date();
      var date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      var dateTime = date + " " + time;
      let data = JSON.stringify({
        status: "approved",
        retained_status:"retained",
        client_id: this.btmdata.client_id,
        rejected_reason: "",
        approved_type: this.btmdata.request,
        app_status:this.btmdata.app_status,
        branch_id:this.btmdata.branch_id  ? this.btmdata.branch_id  : "",
        log: {datetime: dateTime, IP_address: this.ipaddress, browser: navigator.appCodeName, Location: this.geolocation, emp_emailid: this.uemail, emp_ID: this.uuid},
      });

      let config = {
        method: "post",
        url: `${apirkyc}/status_update`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          if (response.data) {
            axiosThis.retaineddia = false;
            axiosThis.btmsheet = false;
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "#2a2a2a";
            axiosThis.snackmsgbar = response.data.msg ? response.data.msg : response.data;
            axiosThis.btmdata = [];
            // axiosThis.tab = 1;
            axiosThis.getDashboard();
            axiosThis.completebtn = false;
          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
        });
    },
    bfoRejection() {
      this.rejectreason = "";
      this.rejdialog = true;
      this.$refs.form.reset();
    },
    retainedfun(){
  this.retaineddia = true;
    },
    setReject() {
      if (this.$refs.form.validate() == true) {
        this.rejbtn = true;
        var today = new Date();
        var date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
        var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        var dateTime = date + " " + time;

        let data = JSON.stringify({
          status: "rejected",
          client_id: this.btmdata.client_id,
          rejected_reason: this.rejectreason,
          rejection_type: this.btmdata.request,
          app_status:this.btmdata.app_status,
          branch_id:this.btmdata.branch_id  ? this.btmdata.branch_id  : "",
          branch_mail: this.btmdata.request != "closure" ?  this.btmdata.branch_email : this.btmdata.branch_email_id,
          log: {datetime: dateTime, IP_address: this.ipaddress, browser: navigator.appCodeName, Location: this.geolocation, emp_emailid: this.uemail, emp_ID: this.uuid},
        });

        let config = {
          method: "post",
          url: `${apirkyc}/status_update`,
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };

        let axiosThis = this;
        axios
          .request(config)
          .then((response) => {
            console.log(JSON.stringify(response.data));
            if (response.data) {
              axiosThis.rejdialog = false;
              axiosThis.btmsheet = false;
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "#2a2a2a";
              axiosThis.snackmsgbar = response.data.msg ? response.data.msg : response.data;
              axiosThis.btmdata = [];
              // axiosThis.tab = 2;
              axiosThis.getDashboard();
              axiosThis.rejbtn = false;
            }
          })
          .catch((error) => {
            console.log(error);
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "#FF1717";
            axiosThis.snackmsgbar = error.message ? error.message : error;
          });
      }
    },
    async getPublicIP() {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        this.ipaddress = data.ip;
      } catch (error) {
        console.error(error);
        this.ipaddress = null;
      }
    },
    showPosition(position) {
      this.geolocation = `La: ${position.coords.latitude}, Lo: ${position.coords.longitude}, ac: ${position.coords.accuracy}`;
    },
    dateClear() {
      this.alldate = "";
      this.dateSelect2 = "";
      this.dateSelectto = "";
      this.page = 1;
      this.getDashboard();
    },
    dayCustom() {
      let dateis = `${new Date(this.dateSelect2).toDateString().slice(3)} ${new Date(this.dateSelect2).toLocaleString("en-US", {hour: "numeric", minute: "numeric", hour12: true})}`;
      let dateto = `${new Date(this.dateSelectto).toDateString().slice(3)} ${new Date(this.dateSelectto).toLocaleString("en-US", {hour: "numeric", minute: "numeric", hour12: true})}`;
      this.alldate = `${dateis.slice(0, 7)} ~ ${dateto.slice(0, 12)}`;
      this.page = 1;
      this.getDashboard();
    },
    getGenlogs(reason, data) {
      var today = new Date();
      var date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      var dateTime = date + " " + time;
      var raw = {datetime: dateTime, IP_address: this.ipaddress, browser: navigator.appCodeName, Location: this.geolocation, emp_emailid: this.uemail, emp_ID: this.uuid, reason: reason ? reason : ""};
      var combo = data ? {...data, ...raw} : raw;
      return combo;
    },
    setKRAvalidation(item) {
    this.btmdata = item
    //  await this.set_kracheck()
      this.krastatdata = [];
      this.karstatupmob = item;
      this.bottomload = true;
let data;

console.log('Request type:', item.request);
console.log('Email value:', item.email);
console.log('Mobile value:', item.mobile);

if (item.request == 'email') {
  data = JSON.stringify({
    modification_type: 'email',
    new_email: item.new_email_id
  });

  console.log('EMAIL PAYLOAD:', JSON.parse(data));
} else if(item.request == 'address'){
   data = JSON.stringify({
    modification_type: 'address',
    new_mobile: item.new_mobile_number,
    house: item.house ? item.house : "",
    locality : item.locality ? item.locality : "",
    dist : item.district,
    state : item.state,
    pincode : item.pincode

  });
}
else {
  data = JSON.stringify({
    modification_type: 'mobile',
    new_mobile: item.new_mobile_number
  });

  console.log('MOBILE PAYLOAD:', JSON.parse(data));
}





      let config = {
  method: 'post',
  maxBodyLength: Infinity,
        url: `${apirkyc}/SolicitPANDetailsFetchALLKRA_rekyc?client_id=${item.client_id}`,
     headers: { 
    'Content-Type': 'application/json'
  },
  data : data
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((res) => {
          let kra = res.data;
          axiosThis.krastatdata = res.data;
          if (kra && kra.kra_status && kra.old && kra.new) {
            var raw = [];
            axiosThis.btmdata = item;
            axiosThis.btmdata["valid"] = [];

            if (kra.kra != "1") {
              for (const [key, value] of Object.entries(kra.new)) {
                var ee = [];
                for (const [keys, values] of Object.entries(value)) {
                  var m = (kra.old[key] && kra.old[key][keys] ? kra.old[key][keys] : "") == values ? 1 : 0;
                  ee[keys] = [values, kra.old[key] && kra.old[key][keys] ? kra.old[key][keys] : "", m, m == 1 ? true : false, m == 1 ? 0 : null];
                  if (m != 1) {
                    axiosThis.btmdata.valid.push(keys);
                  }
                }
                raw[key] = {...ee};
              }
              axiosThis.cor_addr = {...raw.cor_addr};
              axiosThis.per_addr = {...raw.per_addr};
              axiosThis.per_details = {...raw.personal_details};
              axiosThis.btmdata["item"] = item;
            } else {
              axiosThis.cor_addr = {};
              axiosThis.per_addr = {};
              axiosThis.per_details = {};
            }

   axiosThis.el = kra.complete_kra == "1" ? 4 : kra.kraDocumentUploaded == "1" ? 3 : kra.kra == "1" ? 2 : 1;            axiosThis.btmdata["mode"] = Object.entries(kra.old.personal_details).length > 0 ? true : false;
            axiosThis.btmdata["reskra"] = kra;
            axiosThis.kradialog = true;
          } else {
            axiosThis.kradialog = false;
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "warning";
            axiosThis.snackmsgbar = kra.emsg ? kra.emsg : kra;
          }
          axiosThis.delbtn = false;
          axiosThis.bottomload = false;
        })
        .catch((error) => {
          axiosThis.bottomload = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#2a2a2a";
          axiosThis.snackmsgbar = error;
        });
    },
 async   setKRApushedit() {
      this.bottomload = true;
      this.delbtn = true;
      var kramodifi = this.btmdata.mode
        ? {
            kra_status: this.btmdata.reskra.kra_status,
            edit: {},
            old: this.btmdata.reskra.old,
            new: this.btmdata.reskra.new,
          }
        : {};

      if (this.btmdata.mode) {
        for (const [key, value] of Object.entries({cor_addr: this.cor_addr, per_addr: this.per_addr, personal_details: this.per_details})) {
          var ee = {};
          for (const [keys, values] of Object.entries(value)) {
            ee[keys] = values[values[4]] ? values[values[4]] : values[values[0]];
          }
          kramodifi["edit"][key] = {...ee};
        }
      }
      kramodifi["log"] = this.getGenlogs();
      kramodifi["email_time_after_esign"] = this.btmdata.approval_date_time;
      kramodifi["aadhar_no"] = this.btmdata.aadhaar_no ? this.btmdata.aadhaar_no : ''
      kramodifi["modification_type"] = this.btmdata.request;
      kramodifi["client_id"] = this.btmdata.client_id;



      let data = JSON.stringify(kramodifi);

      let config = {
        method: "post",
        url: `${apirkyc}/modifiy_kra_rkyc`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      let axiosThis = this;
      axios
        .request(config)
        .then(async (res) => {
          axiosThis.snackbar = true;
          if (res.data) {
            axiosThis.snackmsgbar = res.data.Msg ? res.data.Msg : (typeof res.data === 'string' ? res.data : JSON.stringify(res.data));
            if (res.data.KYCDATA && res.data.KYCDATA.APP_MODF_ACK == "1") {
              axiosThis.snackbarclr = "#2a2a2a";
              // await axiosThis.set_kracheck()
              axiosThis.setKRAvalidation(axiosThis.btmdata.item);
            } else if (res.data.Msg && res.data.Msg.includes("PENDING")) {
              axiosThis.snackbarclr = "warning";
              // await axiosThis.set_kracheck()

              axiosThis.setKRAvalidation(axiosThis.btmdata.item);
            } else if (!res.data.KYCDATA) {
              axiosThis.snackbarclr = "#2a2a2a";
              axiosThis.setKRAvalidation(axiosThis.btmdata.item);
            } else {
              axiosThis.snackbarclr = "warning";
              axiosThis.delbtn = false;
              axiosThis.bottomload = false;
            }
              // await axiosThis.set_kracheck()
               axiosThis.setKRAvalidation(axiosThis.btmdata.item);

          } else {
            axiosThis.delbtn = false;
            axiosThis.bottomload = false;
            axiosThis.snackbarclr = "warning";
            axiosThis.snackmsgbar = "No response from KRA";
            axiosThis.setKRAvalidation(axiosThis.btmdata.item);

          }
          
        })
        .catch((error) => {
          console.log(error);
          axiosThis.kradialog = false;
          axiosThis.delbtn = false;
          axiosThis.bottomload = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
        });
    },

    set_kracheck(){
      // this.uploadresdata = []
const axios = require('axios');
let data = "";

let config = {
  method: 'post',
  maxBodyLength: Infinity,
  url: `${apirkyc}/kracheck?client_id=${this.btmdata.client_id}&modify_type=get_${this.btmdata.request}`,
  headers: { 
   
  },
  data : data
};
var axiosThis = this
axios.request(config)
.then((response) => {
  console.log(JSON.stringify(response.data));
  axiosThis.uploadresdata = response.data
})
.catch((error) => {
  console.log(error);
});

    },


    setUPloadKra() {
      this.bottomload = true;
      this.delbtn = true;

      let data = {
        log: this.getGenlogs(),
        "modification_type":this.btmdata.request

      };

      let config = {
        method: "post",
        url: `${apirkyc}/cvlkra_upload_sftp_rekyc/${this.btmdata.client_id}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(data),
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((res) => {
          if (res.data && res.data.success == true) {
            axiosThis.snackbarclr = "success";
            axiosThis.setKRAvalidation(this.tab == 1 ? axiosThis.btmdata : axiosThis.btmdata.item);
          } else {
            axiosThis.delbtn = false;
            axiosThis.bottomload = false;
            axiosThis.snackbarclr = "warning";
          }
          axiosThis.snackbar = true;
          axiosThis.snackmsgbar = res.data && res.data.msg ? res.data.msg : res.data;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.kradialog = false;
          axiosThis.delbtn = false;
          axiosThis.bottomload = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "error";
          axiosThis.snackmsgbar = error;
        });
    },
    setKRAfiledchanges(key, index, n, type) {
      if (type == 0) {
        this.$set(this.cor_addr, key, n);
        this.cor_addr[key] = [...n];
      } else if (type == 1) {
        this.$set(this.per_addr, key, n);
        this.per_addr[key] = [...n];
      } else if (type == 2) {
        this.$set(this.per_details, key, n);
        this.per_details[key] = [...n];
      }
      if (key == "all") {
        Object.keys(this.cor_addr).forEach((i) => {
          this.cor_addr[i][4] = index;
          this.cor_addr[i] = [...this.cor_addr[i]];
        });
        Object.keys(this.per_addr).forEach((i) => {
          this.per_addr[i][4] = index;
          this.per_addr[i] = [...this.per_addr[i]];
        });
        Object.keys(this.per_details).forEach((i) => {
          this.per_details[i][4] = index;
          this.per_details[i] = [...this.per_details[i]];
        });
        this.btmdata.valid = [];
      }
      if (key != "all" && this.btmdata.valid.includes(key) && n && n[4] >= 0) {
        this.btmdata.valid.splice(this.btmdata.valid.indexOf(key), 1);
      }
    },
    revertkrastatus() {
      console.log('this.karstatupmob',this.karstatupmob);
      
      this.krareverload = true;
      let data = JSON.stringify({
        log: this.getGenlogs(),
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apirkyc}/updateKRA?client_id=${this.karstatupmob.client_id}&modify_type=${this.karstatupmob.request} `,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };
      var axiosThis = this;
      axios.request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        axiosThis.krareverload = false;
        axiosThis.snackbar = true;
        axiosThis.snackbarclr = "green";
        axiosThis.snackmsgbar = response.data.msg;
        axiosThis.dialogkraconf = false;
        axiosThis.kradialog = false;
      })
      .catch((error) => {
        console.log(error);
        axiosThis.krareverload = false;
        axiosThis.snackbar = true;
        axiosThis.snackbarclr = "#FF1717";
        axiosThis.snackmsgbar = error;
        axiosThis.dialogkraconf = false;
        axiosThis.kradialog = false;
      });
    },
    downloadApprovedReport() {
      if (!this.dateSelect2 || !this.dateSelectto) {
        this.snackbarclr = "warning";
        this.snackmsgbar = "Please select a date range first";
        this.snackbar = true;
        return;
      }
      this.mainloader = true;
      let axiosThis = this;
      const fileBase = `approved_report_${this.dateSelect2}_to_${this.dateSelectto}`;
      const report = axios({
        method: "post",
        url: `${apirkyc}/approved_report`,
        headers: {"Content-Type": "application/json"},
        data: {from: this.dateSelect2, to: this.dateSelectto},
        responseType: "blob",
      });
      // the report has no PAN / branch, so pull them from the completed-tab dashboard rows for the same range
      Promise.all([report, this.getReportClientInfo()])
        .then(([response, info]) => {
          const blob = response.data;
          if (blob && blob.type && blob.type.indexOf("application/json") !== -1) {
            // JSON payload -> parse rows and export to CSV
            return blob.text().then((txt) => {
              let parsed = {};
              try {
                parsed = JSON.parse(txt);
              } catch (e) {
                parsed = {};
              }
              const data = Array.isArray(parsed) ? parsed : parsed.data;
              if (Array.isArray(data) && data.length) {
                exportFromJSON({data: axiosThis.addPanBranch(data, info), fileName: fileBase, exportType: exportFromJSON.types.csv});
              } else {
                axiosThis.snackbarclr = "warning";
                axiosThis.snackmsgbar = (parsed && parsed.msg) || "No approved records for the selected range";
                axiosThis.snackbar = true;
              }
            });
          }
          // binary file (xlsx/csv) -> read the first sheet, add the columns, write it back out
          const isCsv = blob.type && blob.type.indexOf("csv") !== -1;
          return blob.arrayBuffer().then((buf) => {
            const wb = XLSX.read(buf, {type: "array"});
            const sheetName = wb.SheetNames[0];
            const rows = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {defval: "", raw: false});
            wb.Sheets[sheetName] = XLSX.utils.json_to_sheet(axiosThis.addPanBranch(rows, info));
            XLSX.writeFile(wb, `${fileBase}.${isCsv ? "csv" : "xlsx"}`, {bookType: isCsv ? "csv" : "xlsx"});
          });
        })
        .catch((error) => {
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
          axiosThis.snackbar = true;
        })
        .finally(() => {
          axiosThis.mainloader = false;
        });
    },
    // client_id -> {client_pan, branch_code} for every completed request in the selected range
    getReportClientInfo() {
      return axios({
        method: "post",
        url: `${apirkyc}/dashboard?filter=&limit=100000&offset=1`,
        headers: {"Content-Type": "application/json"},
        data: {tab: "com", from: this.dateSelect2, to: this.dateSelectto},
      })
        .then((response) => {
          const info = {};
          (response.data.data || []).forEach((d) => {
            if (d.client_id && !info[d.client_id]) info[d.client_id] = {client_pan: d.client_pan || "", branch_code: d.branch_id || ""};
          });
          return info;
        })
        .catch(() => ({})); // the report still downloads, just with blank PAN / branch
    },
    // insert client_pan and branch_code right after client_name, keeping values the report already has
    addPanBranch(rows, info) {
      return rows.map((row) => {
        const extra = info[row.client_id] || {};
        const out = {};
        Object.keys(row).forEach((k) => {
          if (k == "client_pan" || k == "branch_code") return;
          out[k] = row[k];
          if (k == "client_name") {
            out.client_pan = row.client_pan || extra.client_pan || "";
            out.branch_code = row.branch_code || extra.branch_code || "";
          }
        });
        if (!("client_pan" in out)) out.client_pan = row.client_pan || extra.client_pan || "";
        if (!("branch_code" in out)) out.branch_code = row.branch_code || extra.branch_code || "";
        return out;
      });
    },
    downloadFile(type) {
      let data;
      let fileName;
      if (type == "single") {
        data = [this.btmdata];
        delete data[0].e_signed_pdf_path;
        fileName = `${this.btmdata.client_id}_${this.btmdata.request}`;
      } else {
        data = this.showdata;
        fileName = `${this.tab == 0 ? "view" : this.tab == 1 ? "Complete" : this.tab == 2 ? "Reject" : "file"}${this.alldate ? `_${this.alldate}` : ""}${this.status ? `_${this.status}` : ""}`;
      }
      const exportType = exportFromJSON.types.csv;

      if (data) exportFromJSON({data, fileName, exportType});
    },
  },
  computed: {
    // a reason is only mandatory once "edit" has been clicked in the CDSL modal
    cdslReasonOk() {
      return !this.cdsleditmode || !!(this.cdslreason && this.cdslreason.trim());
    },
    itemsWithSno() {
      return this.showdata.map((d, index) => ({...d, sno: (this.page - 1) * this.pageSize + index + 1}));
    },
    statusOptions() {
      // valid status_filter values depend on the active tab (per new contract)
      if (this.tab == 1) return ["approved", "retained"];
      if (this.tab == 2) return ["rejected"];
      return ["e-signed pending", "e-signed completed"];
    },
    requestTypeOptions() {
      // "retained" status is closure-only, so restrict the request-type choices to closure
      if (this.status === "retained") return ["closure"];
      return ["mobile", "email", "address", "bank", "income", "segment", "closure", "DDPI", "mtf", "nominee"];
    },
    // Show "Send Mail To Branch" only when the branch mail has not gone out yet
    // (0 / empty / null) and the client has finished e-signing.
    canSendBranchMail() {
      const mailStatus = this.btmdata.mail_send_status;
      const notSent = mailStatus === "0" || mailStatus === "" || mailStatus === null || mailStatus === undefined;
      const appStatus = String(this.btmdata.app_status || "").toLowerCase();
      const eSignDone = appStatus === "e-signed completed";
      return notSent && eSignDone;
    },
  },
};
</script>

<style>
@import "../assets/style.css";

/* Auto / Manual segmented pill */
.mode-pill.v-btn-toggle {
  background: #fff !important;
  border: 1px solid #3f51b5;
  border-radius: 999px !important;
  padding: 2px;
}
.mode-pill.v-btn-toggle > .v-btn.v-btn {
  height: 26px !important;
  min-width: 68px !important;
  padding: 0 14px !important;
  border: none !important;
  border-radius: 999px !important;
  background: transparent !important;
  color: #3f51b5 !important;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  transition: background 0.2s ease, color 0.2s ease;
}
.mode-pill.v-btn-toggle > .v-btn.v-btn::before {
  display: none;
}
.mode-pill.v-btn-toggle > .v-btn.v-btn--active {
  background: #3f51b5 !important;
  color: #fff !important;
}
</style>
